const ru = {
    // ==================== COMMON ====================
    common: {
        appName: 'Email Lion',
        loading: 'Загрузка...',
        error: 'Ошибка',
        success: 'Успешно',
        save: 'Сохранить',
        cancel: 'Отмена',
        close: 'Закрыть',
        delete: 'Удалить',
        edit: 'Редактировать',
        create: 'Создать',
        update: 'Обновить',
        back: 'Назад',
        next: 'Далее',
        previous: 'Предыдущий',
        search: 'Поиск',
        refresh: 'Обновить',
        send: 'Отправить',
        confirm: 'Подтвердить',
        yes: 'Да',
        no: 'Нет',
        or: 'или',
        all: 'Все',
        none: 'Нет',
        status: 'Статус',
        name: 'Имя',
        actions: 'Действия',
        date: 'Дата',
        time: 'Время',
        today: 'Сегодня',
        print: 'Печать',
        export: 'Экспорт',
        import: 'Импорт',
        test: 'Проверить',
        enabled: 'Включено',
        disabled: 'Отключено',
        default: 'По умолчанию',
        optional: 'Необязательно',
        required: 'Обязательно',
        noData: 'Нет данных для отображения',
        errorLoadingData: 'Ошибка загрузки данных',
        errorSaving: 'Ошибка сохранения',
        errorDeleting: 'Ошибка удаления',
        voiceBlocked: 'Браузер заблокировал микрофон. Разрешите доступ в настройках сайта и попробуйте снова.',
        voiceNeedReload: 'Микрофон уже разрешён в настройках, но страница это ещё не видит. Обновите страницу и снова нажмите на микрофон.',
        voiceNoDevice: 'Микрофон не найден. Проверьте, что устройство подключено и разрешено в системе.',
        voiceBusy: 'Микрофон занят другим приложением. Закройте Zoom, Teams или Meet и попробуйте снова.',
        voiceSpeechFailed: 'Распознавание речи не удалось. Попробуйте снова или обновите страницу.',
        voiceNotSupported: 'Голосовой ввод не поддерживается в этом браузере. Используйте Chrome.',
        voiceInputTooltip: 'Голосовой ввод',
        voiceStop: 'Остановить запись',
        voiceListening: 'Слушаю... говорите',
        upgradeRequired: 'Чтобы использовать этот модуль, обновите тарифный план или обратитесь к администратору системы.',
        viewPlans: 'Посмотреть тарифы и обновить',
        files: 'Файлы',
        from: 'От',
        subject: 'Тема',
        noSubject: '(Без темы)',
        email: 'Эл. почта',
        password: 'Пароль',
        emailAccount: 'Почтовый аккаунт',
        runNow: 'Запустить сейчас',
        description: 'Описание',
        errorLoadingAccounts: 'Ошибка загрузки аккаунтов',
        errorStatusChange: 'Ошибка изменения статуса',
        errorLogin: 'Ошибка входа',
        use: 'Использовать',
        recommended: 'Рекомендуется',
        free: 'Бесплатно',
    },

    // ==================== LOGIN ====================
    login: {
        subtitle: 'Корпоративная почтовая система',
        loginTab: 'Вход',
        registerTab: 'Бесплатная регистрация',
        emailLabel: 'Эл. почта',
        passwordLabel: 'Пароль',
        twoFactorLabel: 'Код двухфакторной аутентификации (2FA)',
        twoFactorHelper: 'Введите код из приложения-аутентификатора',
        verifyAndLogin: 'Подтвердить и войти',
        loginButton: 'Войти',
        forgotPassword: 'Забыли пароль',
        fullName: 'Полное имя *',
        emailRequired: 'Эл. почта *',
        passwordRequired: 'Пароль *',
        minChars: 'Не менее 6 символов',
        confirmPassword: 'Подтверждение пароля *',
        passwordsMismatch: 'Пароли не совпадают',
        companyName: 'Название компании (необязательно)',
        phone: 'Телефон *',
        phoneHelper: 'Действующий номер (минимум 9 цифр)',
        registering: 'Регистрация...',
        registerFree: 'Зарегистрироваться бесплатно',
        freePlan: 'Бесплатный тариф · Без банковской карты · 1 почтовый ящик',
        googleLogin: 'Войти через Google',
        googleRegister: 'Зарегистрироваться через Google',
        termsAgree: 'Регистрируясь, я соглашаюсь с',
        termsOfService: 'Условиями использования',
        privacyPolicy: 'Политикой конфиденциальности',
        backToSite: 'Вернуться на главную страницу',
        resetPassword: 'Сброс пароля',
        stepEnterEmail: 'Ввод эл. почты',
        stepVerifyCode: 'Проверка кода',
        stepNewPassword: 'Новый пароль',
        resetEmailPrompt: 'Введите свой адрес эл. почты, и мы отправим вам код для сброса пароля.',
        emailAddress: 'Адрес эл. почты',
        codeSentTo: 'Код подтверждения отправлен на ',
        enterCode: '. Введите код:',
        verificationCode: 'Код подтверждения (6 цифр)',
        newPasswordPrompt: 'Введите новый пароль (не менее 6 символов):',
        newPassword: 'Новый пароль',
        confirmPasswordLabel: 'Подтверждение пароля',
        sendCode: 'Отправить код',
        verifyCode: 'Проверить код',
        resetPasswordBtn: 'Сбросить пароль',
        sessionExpired: 'Сеанс истёк. Пожалуйста, войдите снова.',
        errorFullName: 'Пожалуйста, введите полное имя',
        errorValidEmail: 'Пожалуйста, введите корректный адрес эл. почты (не временный)',
        errorPhone: 'Пожалуйста, введите корректный телефон (минимум 9 цифр)',
        errorMinPassword: 'Пароль должен содержать не менее 6 символов',
        errorPasswordMatch: 'Пароли не совпадают',
        registerSuccess: 'Регистрация завершена! Теперь вы можете войти.',
        errorRegister: 'Ошибка регистрации',
        errorGoogleAuth: 'Ошибка аутентификации Google',
        errorGoogleFailed: 'Аутентификация Google не удалась, попробуйте ещё раз.',
        errorGoogleUnavailable: 'Сервис Google сейчас недоступен',
        errorEnterEmail: 'Пожалуйста, введите адрес эл. почты',
        errorSendCode: 'Ошибка отправки кода',
        errorEnterCode: 'Пожалуйста, введите 6-значный код',
        errorResetPassword: 'Ошибка сброса пароля',
        and: 'и с',
        rememberMe30: 'Запомнить меня на 30 дней',
        keepLoggedInForever: 'Оставаться в системе на этом устройстве',
        keepLoggedInHint: 'Рекомендуется для личного мобильного телефона. Не используйте на общем компьютере.',
    },

    // ==================== LAYOUT ====================
    layout: {
        dashboard: 'Панель управления',
        webmail: 'Почта',
        calendar: 'Календарь',
        orgManagement: 'Организация',
        organizations: 'Организации',
        domains: 'Домены',
        mailboxes: 'Почтовые ящики',
        users: 'Пользователи',
        operations: 'Биллинг и операции',
        plans: 'Тарифы и хранилище',
        proposals: 'Коммерческие предложения',
        billing: 'Биллинг',
        branding: 'Брендинг',
        monitoring: 'Безопасность',
        reports: 'Отчёты и журналы',
        systemHealth: 'Состояние системы',
        auditLog: 'Журнал аудита',
        tools: 'Инструменты',
        aiAgent: 'Личный AI-агент',
        automations: 'AI-автоматизации',
        filing: 'Архивация документов',
        smartCleanup: 'Умная очистка AI',
        autoReplyLog: 'Журнал ответов AI',
        migration: 'Миграция почты',
        marketingCockpit: 'Маркетинг',
        salesEngine: 'Движок продаж',
        integrations: 'Интеграции',
        settings: 'Настройки',
        viewingAsUser: 'Просмотр от имени пользователя',
        backToAdmin: 'Вернуться в админ-панель',
        viewingAsUserClick: 'Просмотр от имени пользователя — нажмите, чтобы вернуться',
        website: 'Сайт',
        backToWebsite: 'Вернуться на сайт',
        help: 'Помощь',
        helpCenter: 'Центр помощи',
        helpTooltip: 'Помощь и обучение',
        darkMode: 'Тёмная тема',
        lightMode: 'Светлая тема',
        expandMenu: 'Развернуть меню',
        collapseMenu: 'Свернуть меню',
        logout: 'Выйти',
        language: 'Язык',
        roles: {
            super_admin: 'Суперадминистратор',
            multi_org_admin: 'Администратор нескольких организаций',
            org_admin: 'Администратор организации',
            user: 'Пользователь',
        },
    },

    // ==================== SMART CLEANUP ====================
    cleanup: {
        title: 'Агент умной очистки AI',
        subtitle: 'Умное сканирование вашего почтового ящика: выявление рассылок, спама, старых писем, больших файлов и дубликатов. Отписывайтесь, удаляйте, перемещайте в папки и наводите порядок с умом.',
        startScan: 'Начать сканирование',
        scanning: 'Сканирование...',
        errorScan: 'Ошибка запуска сканирования',
        errorScanResult: 'Ошибка сканирования',
        noAccountTitle: 'Подключите почтовый аккаунт, чтобы использовать агент очистки',
        noAccountSubtitle: 'Сначала перейдите в Почту и подключите почтовый ящик',
        readyTitle: 'Готовы навести порядок в почтовом ящике?',
        readySubtitle: 'Умный агент просканирует ваш ящик, найдёт рассылки, спам, старые и большие письма и предложит умные действия по очистке. Выберите, что удалить, переместить или архивировать.',
        startSmartScan: 'Начать умное сканирование',
        newsletters: 'Рассылки',
        newslettersDesc: 'Письма с возможностью отписки',
        spam: 'Спам',
        spamDesc: 'Письма, похожие на спам',
        old: 'Старые (6+ месяцев)',
        oldDesc: 'Письма старше 6 месяцев',
        large: 'Большие (5MB+)',
        largeDesc: 'Письма с большими вложениями',
        notifications: 'Уведомления',
        notificationsDesc: 'Автоматические уведомления',
        duplicates: 'Дубликаты',
        duplicatesDesc: 'Письма с одинаковыми темами',
        deselectAll: 'Снять выделение',
        selectAll: 'Выбрать все',
        selected: 'выбрано',
        deleteSelected: 'Удалить выбранные',
        deleteBtn: 'Удалить',
        moveToFolder: 'Переместить в папку',
        moveBtn: 'Переместить',
        archive: 'Архив',
        markSpam: 'Пометить как спам',
        spamBtn: 'Спам',
        markRead: 'Пометить как прочитанное',
        readBtn: 'Прочитано',
        page: 'Страница',
        noneFound: 'В этой категории писем не найдено',
        unsubscribe: 'Отписаться',
        unsubscribeTooltip: 'Отписаться от рассылки',
        deleteConfirmTitle: 'Подтверждение удаления',
        deleteConfirmMsg: 'Будет удалено {count} писем. Удалённые письма невозможно восстановить.',
        deleteCount: 'Удалить {count} писем',
        moveTitle: 'Переместить в папку',
        movePrompt: 'Выберите целевую папку для {count} писем:',
        folderName: 'Название папки',
        folderPlaceholder: 'например: Рассылки, Клиенты, Архив...',
        folderHelper: 'Введите название существующей или новой папки',
        executedResult: 'Готово: {success} успешно, {failed} не удалось',
        errorExecute: 'Ошибка выполнения действия',
        rescan: 'Пересканировать',
        loadingCached: 'Загрузка результатов предыдущего сканирования...',
        cachedLabel: 'Из кэша',
        lastScanAt: 'Последнее сканирование: {date}',
        insightsSummary: 'Просканировано {total} писем · Найдено {items} элементов для обработки',
        organizeBtn: 'Разложить по папкам',
        organizeTooltip: 'Автоматически переместить рассылки, уведомления и спам в упорядоченные папки',
        organizeTitle: 'Автоматическая раскладка по папкам',
        organizeDesc: 'Умный агент автоматически переместит письма в упорядоченные папки на основе классификации сканирования:',
        organizeInfo: 'Несуществующие папки будут созданы автоматически. Перемещённые письма покинут INBOX.',
        organizeComplete: 'Раскладка успешно завершена!',
        organizeSuccess: 'INBOX успешно разложен по папкам',
        organizing: 'Раскладываю...',
        organizeNow: 'Разложить сейчас',
        errorOrganize: 'Ошибка раскладки по папкам',
        movedToFolder: 'перемещено в папку',
        failedItems: 'Не удалось',
        foldersCreated: 'Создано папок',
    },

    // ==================== CALENDAR ====================
    calendar: {
        days: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        newEvent: 'Новое событие',
        editEvent: 'Редактировать событие',
        title: 'Название',
        descriptionLabel: 'Описание',
        location: 'Место',
        start: 'Начало',
        end: 'Окончание',
        allDay: 'Весь день',
        color: 'Цвет:',
        month: 'Месяц',
        week: 'Неделя',
        day: 'День',
        addEvent: 'Добавить событие',
        eventCreated: 'Событие успешно создано',
        eventUpdated: 'Событие обновлено',
        eventDeleted: 'Событие удалено',
        eventMoved: 'Событие перемещено',
        undo: 'Отменить',
        redo: 'Повторить',
        undoDone: 'Отменено',
        redoDone: 'Повторено',
        undoFailed: 'Не удалось отменить',
        redoFailed: 'Не удалось повторить',
        deleteEvent: 'Удалить это событие?',
        errorSaving: 'Ошибка сохранения',
        errorDeleting: 'Ошибка удаления',
        requiredFields: 'Название, дата начала и дата окончания обязательны',
        noReminder: 'Без напоминания',
        min5: 'За 5 минут',
        min10: 'За 10 минут',
        min15: 'За 15 минут',
        min30: 'За 30 минут',
        hour1: 'За 1 час',
        hour2: 'За 2 часа',
        day1: 'За 1 день',
        once: 'Однократно',
        daily: 'Ежедневно',
        weekly: 'Еженедельно',
        monthly: 'Ежемесячно',
        yearly: 'Ежегодно',
        printCalendar: 'Печать календаря',
        printPrompt: 'Выберите вид для печати:',
        dailyView: 'День',
        weeklyView: 'Неделя',
        monthlyView: 'Месяц',
        yearlyView: 'Год',
        yearLabel: 'Год',
        weekLabel: 'Неделя',
        printWindowBlocked: 'Окно печати было заблокировано — разрешите всплывающие окна',
        syncCalendar: 'Синхронизация календаря',
        syncTooltip: 'Синхронизация iCal',
        subscriptionUrl: 'URL подписки',
        subscriptionHelper: 'Скопируйте URL и добавьте его как внешний календарь',
        copy: 'Копировать',
        regenerate: 'Новый',
        syncUrlCopied: 'URL синхронизации скопирован',
        syncUrlRegenerated: 'Создан новый URL синхронизации',
        exportIcs: 'Экспорт ICS',
        importIcs: 'Импорт ICS',
        exportDone: 'Файл скачан',
        importDone: 'Импортировано {count} событий',
        errorExport: 'Ошибка экспорта',
        errorImport: 'Ошибка импорта',
        exportImport: 'Экспорт / Импорт',
        externalSyncTitle: 'Автоматическая двусторонняя синхронизация',
        externalSyncHelper: 'Подключите Google Calendar или Outlook — события появятся здесь и будут синхронизироваться в обе стороны.',
        connectGoogle: 'Подключить Google Calendar',
        connectOutlook: 'Подключить Outlook',
        disconnectGoogle: 'Отключить Google',
        disconnectOutlook: 'Отключить Outlook',
        syncNow: 'Синхронизировать сейчас',
        syncDone: 'Синхронизация завершена',
        syncFailed: 'Ошибка синхронизации',
        connectedAs: 'Подключено как {email}',
        lastSync: 'Последняя синхронизация: {time}',
        sourceGoogle: 'Google',
        sourceOutlook: 'Outlook',
        sourceLocal: 'Локально',
        notConfiguredGoogle: 'Google Calendar OAuth не настроен на сервере',
        notConfiguredOutlook: 'Outlook Calendar OAuth не настроен на сервере',
        calendarHint: 'Email Lion — Календарь',
        aiAgent: 'AI-агент календаря',
        aiAgentTooltip: 'Умный AI-агент',
        aiHello: 'Привет! Я ваш агент календаря',
        aiSubtitle: 'Скажите простыми словами, что запланировать',
        aiPlaceholder: 'Скажите, что запланировать, и я всё сделаю',
        aiInputPlaceholder: 'например: "Встреча команды в четверг в 15:00"',
        aiDaySummary: 'Сводка дня',
        aiThinking: 'Думаю...',
        voiceInputTooltip: 'Голосовой ввод',
        voiceStop: 'Остановить запись',
        voiceListening: 'Слушаю... говорите',
        voiceNotSupported: 'Голосовой ввод не поддерживается в этом браузере',
        aiErrorSummary: 'Ошибка получения сводки дня',
        requestProcessed: 'Запрос успешно обработан.',
        eventsCreated: 'Создано {count} событий:',
        more: 'ещё',
        reminder: 'Напоминание',
        reminderSnack: '🔔 Напоминание: {title} в {time}',
        reminderBody: 'В {time}',
        aiCreatedEvents: '📅 Создано {count} событий:',
        aiNoResponse: 'Ответ не получен.',
        aiSummaryPrefix: '📊 Сводка за {date}:',
        aiNoInfo: 'Нет информации',
        aiExampleChip: 'Встреча завтра в 10',
        aiExampleChipPrompt: 'Запланируй встречу завтра в десять утра в Тель-Авиве с поставщиком',
        aiExample1: 'Запланируй встречу завтра в десять утра в Тель-Авиве',
        aiExample2: 'Создай 3 еженедельных напоминания: обзор, команда и итоги',
        aiExample3: 'Срочное заседание правления сегодня в 16:00 + напоминание',
        syncCopyTooltip: 'Копировать',
        syncRegenerateTooltip: 'Создать заново',
        syncGoogleInstructions: 'Настройки — Добавить календарь — По URL',
        syncAppleInstructions: 'Файл — Новая подписка',
        syncOutlookInstructions: 'Добавить календарь — Подписаться из интернета',
        icalGoogleWarning: 'Google Calendar уже подключён двусторонней синхронизацией. Не добавляйте iCal URL в Google — это дублирует каждое событие. Снимите отметку с «Email Lion Calendar» в левой панели Google Calendar. Ссылка iCal только для Apple Calendar или другого календаря.',
        dedupeButton: 'Удалить дубликаты',
        dedupeConfirm: 'Удалить дублирующие строки в Email Lion (одно и то же событие дважды)? События в самом Google не будут удалены — если дубликаты там, снимите «Email Lion Calendar» в левой панели.',
        dedupeDone: 'Удалено дубликатов: {count}',
        dedupeNone: 'Дубликаты в Email Lion не найдены',
        aiClearChat: 'Очистить чат',
        aiClearConfirm: 'Очистить историю разговора с агентом?',
    },

    // ==================== AUTOMATIONS ====================
    automations: {
        title: 'AI-автоматизации почты',
        subtitle: 'Создавайте автоматические правила для обработки писем с помощью AI — извлечение данных, сводки, расчёты и многое другое',
        moduleTitle: 'AI-автоматизации почты',
        moduleDesc: 'Работайте умнее — настройте правила, которые автоматически обрабатывают письма и вложения с помощью AI. Извлекайте данные из PDF, составляйте сводки документов, выполняйте расчёты в таблицах и многое другое.',
        moduleFeatures: ['Обработка PDF/Excel/CSV', 'Сводки документов', 'Извлечение данных', 'Вывод в Email/Webhook', '3 движка AI'],
        newAutomation: 'Новая автоматизация',
        editAutomation: 'Редактировать автоматизацию',
        runAllNow: 'Запустить сейчас',
        runAllTooltip: 'Запустить все автоматизации сейчас',
        runningInBackground: 'Автоматизации выполняются в фоновом режиме...',
        errorRunning: 'Ошибка запуска',
        totalAutomations: 'Всего автоматизаций',
        active: 'Активные',
        runs30days: 'Запуски (30 дней)',
        successRate: 'Процент успеха',
        tabMy: 'Мои автоматизации',
        tabHistory: 'История запусков',
        tabTemplates: 'Шаблоны',
        noAutomations: 'Автоматизаций пока нет. Создайте первую или выберите шаблон!',
        noRuns: 'Запусков пока нет',
        filters: 'Фильтры',
        output: 'Вывод',
        runsCount: 'Запуски',
        lastRun: 'Последний запуск',
        outputEmail: 'Отправить по эл. почте',
        outputWebhook: 'Webhook (Zapier/Make)',
        outputDownload: 'Скачать как PDF',
        outputEmailWebhook: 'Email + Webhook',
        formatText: 'Свободный текст',
        formatJson: 'Структурированный JSON',
        formatTable: 'Таблица',
        formatSummary: 'Сводка по пунктам',
        statusSuccess: 'Успешно',
        statusFailed: 'Не удалось',
        statusProcessing: 'Обработка...',
        statusSkipped: 'Пропущено',
        automationUpdated: 'Автоматизация обновлена',
        automationCreated: 'Автоматизация создана',
        automationDeleted: 'Автоматизация удалена',
        deleteConfirm: 'Удалить эту автоматизацию?',
        testCompleted: 'Тест успешно завершён',
        testTimeout: 'Тест занял слишком много времени. Попробуйте ещё раз.',
        testConnectionLost: 'Соединение с сервером потеряно. Возможно, сервер перезапускается — попробуйте снова через 30 секунд.',
        testFailed: 'Тест не пройден — проверьте настройки AI и почтовый ящик',
        downloadPdfError: 'Ошибка скачивания PDF',
        useTemplate: 'Использовать шаблон',
        downloadPdf: 'Скачать как PDF',
        stepTrigger: 'Триггер и фильтры',
        stepAi: 'Обработка AI',
        stepOutput: 'Вывод и доставка',
        automationName: 'Название автоматизации',
        descriptionOptional: 'Описание (необязательно)',
        filterFrom: 'От (адрес или его часть, поддерживается /regex/)',
        filterFromHelper: 'Разделяйте несколько адресов запятыми. Пример: accounting@, billing@company.com или /.*@company\\.co\\.il/',
        filterSubject: 'Тема содержит (ключевые слова через запятую)',
        filterSubjectHelper: 'Пример: счёт,квитанция,заказ',
        filterBody: 'Текст содержит (ключевые слова)',
        blockedSenders: 'Заблокированные отправители',
        blockedSendersHelper: 'Адреса эл. почты или домены для блокировки, через запятую. Пример: spam@example.com, noreply@domain.com',
        onlyWithAttachment: 'Только письма с вложениями',
        fileType: 'Тип файла',
        fileTypeAll: 'Все',
        fileTypeImage: 'Изображение',
        fileTypeAny: 'Любой тип',
        aiEngine: 'Движок AI',
        aiDefault: 'По умолчанию (из настроек)',
        aiOpenai: 'OpenAI (GPT-4o) — лучший для Excel',
        aiAnthropic: 'Anthropic (Claude) — лучший для PDF',
        aiGoogle: 'Google (Gemini) — быстрый и эффективный',
        outputFormat: 'Формат вывода',
        aiPrompt: 'Промпт AI (инструкции по обработке)',
        aiPromptHelper: 'Можно использовать переменные: {email_body}, {attachment_content}, {sender}, {subject}, {date}',
        includeBody: 'Включить текст письма',
        includeAttachments: 'Включить вложения',
        aiTips: 'Советы:',
        aiTipsText: 'Claude отлично читает сложные PDF. GPT-4o отлично анализирует таблицы и числа. Gemini быстрый и эффективный для больших объёмов обработки.',
        outputType: 'Тип вывода',
        sendTarget: 'Куда отправить',
        sendToSelf: 'Мой аккаунт (по умолчанию)',
        sendToSender: 'Ответить отправителю',
        sendToCustom: 'Свой адрес',
        customEmail: 'Свой адрес эл. почты',
        customEmailHelper: 'Пример: ops@company.com',
        emailSubjectTemplate: 'Шаблон темы письма',
        emailSubjectHelper: 'Можно использовать: {subject}, {automation_name}',
        attachAsPdf: 'Прикрепить результат как PDF',
        webhookHeaders: 'Webhook Headers (JSON, необязательно)',
        webhookInfo: 'Webhook отправит JSON с полями: automation_name, trigger (from, subject, date), result (text, format). Если формат вывода — JSON, поле result.parsed будет содержать разобранный JSON.',
        limits: 'Ограничения',
        maxRunsPerDay: 'Макс. запусков в день',
        activeHoursStart: 'Час начала',
        activeHoursEnd: 'Час окончания',
        enableImmediately: 'Включить автоматизацию сразу после сохранения',
        testResultTitle: 'Результат теста',
        aiResult: 'Результат AI:',
        sentTo: 'Отправлено:',
        inputSentToAi: 'Входные данные, отправленные в AI:',
        processingTime: 'Время обработки:',
        testedWithReal: 'Протестировано на реальном письме',
        testedWithMock: 'Протестировано на тестовом письме (реальное письмо в ящике не найдено)',
        createAutomation: 'Создать автоматизацию',
        fromFilter: 'От:',
        subjectFilter: 'Тема:',
        attachment: 'Вложение',
        // Multi-output (filing / cloud)
        additionalOutputs: 'Дополнительные выводы',
        fileToCloud: 'Также сохранить в Google Drive / Dropbox',
        filingConnection: 'Подключение для архивации',
        filingFolderPath: 'Путь к целевой папке (необязательно)',
        filingFolderHelper: 'Разделяется "/". Поддерживает переменные: {date}, {subject}, {from_name}, {automation_name} и поля JSON из вывода AI.',
        fileAttachments: 'Сохранить вложения',
        fileEmailBody: 'Сохранить текст письма',
        fileAiResult: 'Сохранить результат AI',
        noFilingConnections: 'Нет активного подключения к Google Drive / Dropbox. Добавьте его на странице "Архивация", чтобы включить эту опцию.',
        filingNeedsConnection: 'Для включения архивации как вывода требуется подключение Drive/Dropbox.',
        emailBodyTemplate: 'Шаблон текста письма (необязательно)',
        emailBodyHelper: 'Если пусто, текстом письма будет необработанный вывод AI. Поддерживает те же переменные, что и строка темы.',
        templateVarsHelper: 'Доступные переменные: {subject}, {from_name}, {from}, {date}, {date:dd/MM}, {ai_result} (также {ai_text}). Если вывод AI — JSON, также {{vendor}}, {{amount}}, {ai_json.amount} и т.д.',
        // Workflow output targets
        createTaskOption: 'Создать задачу автоматизации (Task Manager)',
        generateReplyDraftOption: 'Создать черновик ответа для утверждения (Smart Reply)',
        sendAlertOption: 'Отправить срочное оповещение (Alert)',
        taskDefaultStatus: 'Статус по умолчанию',
        taskDefaultPriority: 'Приоритет',
        taskDefaultTags: 'Теги (через запятую)',
        taskStatusOpen: 'Открыта',
        taskStatusUrgent: 'Срочная',
        taskStatusWaitingSupplier: 'Ожидает поставщика',
        taskStatusWaitingCustomer: 'Ожидает клиента',
        taskPriorityLow: 'Низкий',
        taskPriorityMedium: 'Средний',
        taskPriorityHigh: 'Высокий',
        taskPriorityUrgent: 'Срочный',
        taskJsonHint: 'Совет: чтобы AI динамически задавал название/статус/приоритет, используйте ai_output_format=json и попросите в промпте вернуть { title, summary, status, priority, tags, followup_hours }.',
        replyDraftDefaultTo: 'Получатель по умолчанию',
        replyDraftDefaultToHelper: 'Оставьте "__sender__", чтобы отвечать исходному отправителю, или укажите фиксированный адрес.',
        alertRecipientsLabel: 'Получатели оповещений (через запятую)',
        alertRecipientsHelper: 'Если пусто, оповещение отправляется на аккаунт автоматизации. Push-уведомление также отправляется пользователю.',
        // Trigger types
        triggerSection: 'Триггер',
        triggerType: 'Тип триггера',
        triggerEmail: 'Входящее письмо (по умолчанию)',
        triggerSchedule: 'По расписанию (ежедневный дайджест / отчёт)',
        triggerFollowup: 'Автоматический follow-up по открытым задачам',
        scheduleTime: 'Время запуска',
        scheduleDays: 'Активные дни',
        scheduleDaysHelper: '0=Вс, 1=Пн, ..., 6=Сб',
        followupWaitHours: 'Сколько часов ждать перед follow-up',
        followupWaitHelper: 'Автоматизация запустит follow-up по задачам, которые не обновлялись в течение этого периода.',
        scheduleTimeInvalid: 'Время запуска должно быть в формате HH:MM',
        followupWaitInvalid: 'Для триггера Follow-Up введите положительное число часов',
        // Reference materials (knowledge base files attached to the prompt)
        referenceMaterials: 'Справочные материалы для этой автоматизации',
        referenceMaterialsHelper: 'Справочные файлы или URL, которые будут прикрепляться при каждом запуске. Полезно для таблиц минимальных заказов, прайс-листов, списков клиентов и т.д. Публичные Google Sheets автоматически скачиваются как CSV.',
        addReferenceMaterial: 'Добавить справочный материал',
        referenceMaterialName: 'Описательное название',
        referenceMaterialUrl: 'URL (Google Sheet / Drive / прямая ссылка)',
        referenceMaterialUrlHelper: 'Публичная таблица Google автоматически скачивается как CSV. Для приватного файла в Drive откройте доступ "всем, у кого есть ссылка".',
        referenceMaterialRemove: 'Удалить',
        // Task manager
        tasksTitle: 'Открытые задачи',
        taskUpdated: 'Задача обновлена',
        taskUpdateError: 'Ошибка обновления задачи',
        taskDeleteConfirm: 'Удалить задачу? Это действие необратимо.',
        taskDeleted: 'Задача удалена',
        taskDeleteError: 'Ошибка удаления',
        taskFilterOpenOnly: 'Только открытые',
        taskFilterUrgent: 'Срочные',
        taskFilterOpen: 'Открытые',
        taskFilterWaitingSupplier: 'Ожидают поставщика',
        taskFilterWaitingCustomer: 'Ожидают клиента',
        taskFilterClosed: 'Закрытые',
        taskFilterAll: 'Все',
        tasksCount: 'Задач: {count}',
        taskColTitle: 'Заголовок / Сводка',
        taskColSource: 'Источник',
        taskColAutomation: 'Автоматизация',
        taskColLastAction: 'Последнее действие',
        noOpenTasks: 'Сейчас нет открытых задач',
        tasksAutoInfo: 'Задачи, созданные автоматически из писем, появятся здесь.',
        taskStatusClosed: 'Закрыта',
        taskPrioUrgent: 'Срочный',
        taskPrioHigh: 'Высокий',
        taskPrioMedium: 'Средний',
        taskPrioLow: 'Низкий',
        taskReopen: 'Открыть заново',
        taskCloseTask: 'Закрыть задачу',
        refNamePlaceholder: 'Таблица минимального заказа',
        emailBodyPlaceholder: 'Пример: Здравствуйте,\nНовый счёт от {from_name}.\nПоставщик: {{поставщик}}, Сумма: {{сумма}}.\n\n{ai_result}',
        filingPathPlaceholder: '{date}/Автоматизации/{from_name}',
        refMaterialsLoadedSummary: 'Справочные материалы: загружено {ok}/{total}',
        extractWarningPrefix: 'Ошибка загрузки содержимого письма / файлов:',
        refMaterialsLoadedTitle: 'Загруженные справочные материалы ({ok}/{total})',
        downloadedFile: 'Скачанный файл:',
        refMaterialChip: 'Справочный материал',
    },

    // ==================== FILING ====================
    filing: {
        title: 'Умная архивация документов',
        subtitle: 'Автоматически сохраняйте вложения из почты в облако с помощью AI',
        skippedNoDocument: 'По ссылке не найден документ для скачивания',
        retryFailedBtn: 'Повторить (неудачные)',
        retryFailedSuccess: 'Неудачные задания поставлены на повтор',
        retryFailedError: 'Ошибка сброса заданий',
        moduleDesc: 'Сохраняйте вложения из почты напрямую в Google Drive или Dropbox — автоматически с помощью AI. Система распознаёт счета, заказы, договоры и многое другое и раскладывает их по упорядоченным папкам.',
        moduleFeatures: ['Google Drive', 'Dropbox', 'AI-распознавание документов', 'Автоматические папки', 'Умная фильтрация'],
        newRule: 'Новое правило архивации',
        editRule: 'Редактировать правило архивации',
        activeRules: 'Активные правила',
        filesFiled: 'Файлов сохранено',
        todayFilings: 'Сохранено сегодня',
        cloudConnections: 'Облачные подключения',
        tabConnections: 'Облачные подключения',
        tabRules: 'Правила архивации',
        tabHistory: 'История',
        googleDriveDesc: 'Сохраняйте вложения напрямую в Google Drive. Система автоматически создаст папки на основе настроек AI.',
        dropboxDesc: 'Сохраняйте вложения напрямую в Dropbox. Система автоматически создаст папки на основе настроек AI.',
        notConnected: 'Не подключено',
        disconnect: 'Отключить',
        connectGoogleDrive: 'Подключить Google Drive',
        connectDropbox: 'Подключить Dropbox',
        connectedSuccess: 'Подключено успешно!',
        connectionError: 'Ошибка подключения:',
        connectFirst: 'Подключите аккаунт Google Drive или Dropbox, чтобы начать автоматически архивировать документы.',
        noRules: 'Нет правил архивации',
        noRulesSubtitle: 'Создайте первое правило архивации, чтобы начать автоматически сохранять документы из почты.',
        connectCloudFirst: 'Сначала подключите облачный аккаунт (Google Drive или Dropbox) на вкладке "Облачные подключения"',
        allEmails: 'Все письма с файлами',
        runsToday: 'Запусков сегодня',
        noHistory: 'Нет истории архивации',
        noHistorySubtitle: 'Как только правила архивации заработают, здесь появится история.',
        rule: 'Правило',
        sender: 'Отправитель',
        filesCount: 'Файлы',
        disconnectConfirm: 'Вы уверены? Правила архивации, использующие это подключение, перестанут работать.',
        connectionRemoved: 'Подключение удалено',
        errorDisconnect: 'Ошибка удаления подключения',
        errorConnection: 'Ошибка подключения',
        ruleUpdated: 'Правило обновлено',
        ruleCreated: 'Правило успешно создано',
        ruleDeleted: 'Правило удалено',
        deleteRuleConfirm: 'Удалить это правило архивации?',
        errorToggle: 'Ошибка изменения статуса',
        manualRunStarted: 'Ручной запуск начат',
        errorManualRun: 'Ошибка начала ручного запуска',
        testResult: 'Результат теста',
        aiClassified: 'AI успешно классифицировал документ (уверенность: {confidence}%)',
        emailLabel: 'Письмо:',
        fileLabel: 'Файл:',
        docType: 'Тип документа:',
        filingPath: 'Путь архивации:',
        filePath: 'Путь',
        fileLink: 'Ссылка',
        fileName: 'Имя файла:',
        destination: 'Назначение:',
        stepSource: 'Источник и фильтры',
        stepAi: 'Инструкции AI',
        stepDestination: 'Назначение и ограничения',
        ruleName: 'Название правила',
        imapFolder: 'Папка IMAP',
        imapDefault: 'По умолчанию: INBOX',
        filterOptional: 'Фильтры (необязательно)',
        filterFrom: 'От (отправитель)',
        filterFromHelper: 'Адрес эл. почты, его часть или несколько через запятую. Пусто = все отправители',
        filterSubject: 'Тема содержит',
        filterSubjectHelper: 'Ключевые слова в теме, через запятую',
        filterBody: 'Текст письма содержит',
        filterAttachment: 'Имя вложения содержит',
        filterAttachmentHelper: 'например: "счёт", "заказ", "договор"',
        blockedSenders: 'Заблокированные отправители',
        blockedSendersHelper: 'Адреса эл. почты или домены для блокировки, через запятую. Пример: spam@example.com, noreply@domain.com',
        aiInstructions: 'Опишите, как вы хотите архивировать документы. Если оставить пустым, AI использует метод по умолчанию: Год > Имя отправителя > Тип документа (счёт/заказ/договор/общее).',
        filingPrompt: 'Инструкции по архивации (Prompt) — необязательно',
        filingPromptPlaceholder: 'Примеры:\n\n• "Раскладывай по папкам: Год > Имя клиента > Тип документа (счета, заказы, договоры)"\n\n• "Сохраняй всё в одну папку с названием \'Входящие документы\' с датой в качестве префикса"\n\n• "Счета поставщиков в \'Расходы > Год > Месяц\', счета клиентам в \'Доходы > Год\'"\n\n• "PDF-файлы, содержащие \'invoice\' — папка Счета. Файлы Excel — папка Отчёты. Остальное — папка Общее"',
        aiEngineOptional: 'Движок AI (необязательно)',
        modelOptional: 'Модель (необязательно)',
        modelHelper: 'Оставьте пустым, чтобы использовать модель по умолчанию',
        cloudTarget: 'Облачное назначение',
        targetFolder: 'Целевая папка:',
        rootFolder: 'Корневая папка',
        resetToRoot: 'Сбросить на корневую папку',
        browseFolder: 'Обзор / Создать новую папку',
        limitsLabel: 'Ограничения',
        maxRunsDay: 'Макс. запусков в день',
        startHour: 'Час начала',
        endHour: 'Час окончания',
        activeDays: 'Активные дни:',
        enableAfterCreate: 'Включить правило сразу после создания',
        selectFolder: 'Выберите целевую папку',
        noSubfolders: 'Здесь нет подпапок',
        noFolders: 'Нет папок',
        createOrSelect: 'Создайте новую папку или выберите текущую',
        newFolderName: 'Название новой папки',
        createFolder: 'Создать',
        folderCreated: 'Папка успешно создана',
        errorCreateFolder: 'Ошибка создания папки',
        selectThisFolder: 'Выбрать эту папку',
        selectCloudFirst: 'Сначала выберите облачное подключение',
        nameRequired: 'Требуется название правила',
        accountRequired: 'Требуется почтовый аккаунт',
        missingRuleName: 'Отсутствует название правила (шаг 1)',
        missingAccount: 'Отсутствует почтовый аккаунт (шаг 1)',
        missingCloud: 'Отсутствует облачное назначение',
        createRule: 'Создать правило',
        fromPrefix: 'От:',
        subjectPrefix: 'Тема:',
        filePrefix: 'Файл:',
        daysShort: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    },

    // ==================== INBOX (Webmail) ====================
    inbox: {
        compose: 'Написать',
        reply: 'Ответить',
        replyAll: 'Ответить всем',
        forward: 'Переслать',
        forwardAttachmentsFailed: 'вложение(я) не удалось загрузить для пересылки — попробуйте снова или прикрепите их вручную',
        to: 'Кому',
        cc: 'Копия',
        bcc: 'Скрытая копия',
        subject: 'Тема',
        noSubject: '(Без темы)',
        send: 'Отправить',
        sending: 'Отправка...',
        emailSent: 'Письмо успешно отправлено!',
        readReceipt: 'Уведомление о прочтении',
        openTracking: 'Отслеживание открытий',
        priority: 'Приоритет',
        priorityHigh: 'Высокий приоритет',
        priorityNormal: 'Обычный',
        priorityLow: 'Низкий приоритет',
        encryption: 'Шифрование',
        schedule: 'Запланировать',
        templates: 'Шаблоны',
        addAttachment: 'Добавить файл',
        attachments: 'Вложения',
        dragFiles: 'Перетащите файлы сюда или нажмите "Добавить файл"',
        snooze: 'Напоминание / Отложить',
        snooze1h: 'Через 1 час',
        snooze3h: 'Через 3 часа',
        snoozeTomorrow: 'Завтра утром',
        snooze2d: 'Через 2 дня',
        snooze1w: 'Через 1 неделю',
        addStar: 'Пометить звездой',
        removeStar: 'Снять звезду',
        selected: 'выбрано',
        deleteSelected: 'Удалить выбранные',
        moveToArchive: 'Переместить в архив',
        markRead: 'Пометить как прочитанное',
        markUnread: 'Пометить как непрочитанное',
        moveToFolder: 'Переместить в папку',
        deselectAll: 'Снять выделение',
        connecting: 'Подключение к почтовому ящику...',
        noResults: 'Результаты не найдены',
        emptyFolder: 'Папка пуста',
        inbox: 'Входящие',
        sentMail: 'Отправленные',
        drafts: 'Черновики',
        spam: 'Спам',
        trash: 'Корзина',
        archive: 'Архив',
        flagged: 'Помеченные',
        allMail: 'Вся почта',
        primary: 'Основные',
        social: 'Соцсети',
        promotions: 'Промоакции',
        updates: 'Обновления',
        quickReplyPlaceholder: 'Быстрый ответ...',
        sendQuickReply: 'Отправить',
        quickReplySent: 'Быстрый ответ отправлен!',
        composePlaceholder: 'Напишите ваше сообщение здесь...',
        addressPlaceholder: 'Введите адрес...',
        searchPlaceholder: 'Поиск писем...',
        aiAssist: 'AI-помощник по написанию',
        aiCompose: 'Написать с AI',
        aiTones: {
            professional: 'Профессиональный',
            friendly: 'Дружелюбный',
            brief: 'Краткий',
            formal: 'Официальный',
            thankful: 'Благодарный',
            decline: 'Вежливый отказ',
        },
        aiTonesDesc: {
            professional: 'Профессиональный и вежливый ответ',
            friendly: 'Тёплый и личный',
            brief: 'Сразу к делу, 3-4 предложения',
            formal: 'Как деловое письмо',
            thankful: 'Выражение признательности',
            decline: 'Мягкий отказ с альтернативой',
        },
        errorSendingEmail: 'Ошибка отправки письма',
        errorLoadingMessage: 'Ошибка загрузки сообщения',
        deleteConfirm: 'Удалить эти сообщения?',
        newFolder: 'Новая папка',
        renameFolder: 'Переименовать',
        deleteFolder: 'Удалить папку',
        folderName: 'Название папки',
        wrote: 'написал(а)',
        forwardedMessage: 'Пересланное сообщение',
        fromLabel: 'От:',
        dateLabel: 'Дата:',
        subjectLabel: 'Тема:',
        printEmail: 'Печать',
        downloadEmail: 'Скачать',
        unifiedInbox: 'Единый ящик',
        newMail: 'Новая почта',
        newMailBody: 'У вас {count} новых сообщений',
        connectionError: 'Ошибка подключения к почтовому ящику',
        connectionCooldown: 'Подключение временно приостановлено из-за предыдущих сбоев. Пытаюсь сбросить...',
        resetDone: 'Сброс выполнен — переподключение...',
        reconnectingAccount: 'Почтовый сервер временно отклонил подключение — повторная попытка...',
        cannotAutoReset: 'Не удаётся выполнить автоматический сброс — обратитесь к администратору',
        mailboxUnavailable: 'Ящик {email} сейчас недоступен, переключаюсь на другой...',
        errorLoadingMessages: 'Ошибка загрузки сообщений',
        errorLoadingUnified: 'Ошибка загрузки единого почтового ящика',
        errorAiReply: 'Ошибка генерации ответа AI',
        errorAiCompose: 'Ошибка написания с AI',
        errorEncryption: 'Ошибка шифрования',
        sendWithoutEncryption: 'Отправить без шифрования?',
        errorSendingPrefix: 'Ошибка отправки: ',
        chooseDateTime: 'Пожалуйста, выберите дату и время',
        emailScheduled: 'Отправка письма успешно запланирована!',
        errorSchedulingPrefix: 'Ошибка планирования: ',
        errorCreatingFolderPrefix: 'Ошибка создания папки: ',
        errorDeletingFolderPrefix: 'Ошибка удаления папки: ',
        errorExportPrefix: 'Ошибка экспорта: ',
        confirmDeleteSearch: 'Удалить все {count} сообщений, соответствующих поиску "{query}"?',
        errorDeletingSearchPrefix: 'Ошибка удаления всех результатов поиска: ',
        errorDeletingPrefix: 'Ошибка удаления: ',
        confirmEmptyFolder: 'Очистить "{folder}"? Все сообщения будут удалены безвозвратно, и их нельзя будет восстановить.',
        errorEmptyingFolderPrefix: 'Ошибка очистки папки: ',
        confirmMoveSearch: 'Переместить все {count} сообщений, соответствующих поиску "{query}", в папку?',
        errorMovingSearchPrefix: 'Ошибка перемещения всех результатов поиска: ',
        errorMovingPrefix: 'Ошибка перемещения: ',
        confirmSpamSearch: 'Пожаловаться на все {count} соответствующих сообщений как на спам?',
        errorSpamSearchPrefix: 'Ошибка отметки всех результатов поиска как спама: ',
        confirmMoveToInbox: 'Переместить все {count} соответствующих сообщений во входящие?',
        errorMoveToInboxPrefix: 'Ошибка перемещения всех результатов поиска во входящие: ',
        archiveNotFound: 'Папка архива не найдена',
        toLabel: 'Кому:',
        ccLabel: 'Копия:',
        noName: 'Без имени',
        lastMsg: 'Последнее',
        firstMsg: 'Первое',
        noText: '(Без текста)',
        noContent: '(Без содержимого)',
        noMessageContent: 'У этого сообщения нет содержимого.',
        pgpPassphrasePrompt: 'Введите парольную фразу шифрования:',
        noEncryptedContent: 'Зашифрованное содержимое не найдено',
        decryptedContent: 'Расшифрованное содержимое:',
        errorDecryption: 'Ошибка расшифровки',
        decrypt: 'Расшифровать',
        pgpEncrypted: 'Это сообщение зашифровано PGP',
        readReceiptSent: 'Уведомление о прочтении отправлено',
        errorSendingReadReceipt: 'Ошибка отправки уведомления о прочтении',
        sendConfirmation: 'Отправить подтверждение',
        senderRequestedReadReceipt: 'Отправитель запросил уведомление о прочтении этого сообщения',
        autoReplied: 'Отвечено автоматически',
        autoRepliedByAI: 'Автоматически отвечено AI',
        aiReplyTooltip: 'Ответить с AI — автоматический ответ',
        aiReplyLabel: 'Ответ AI',
        errorArchive: 'Ошибка перемещения в архив',
        errorDelete: 'Ошибка удаления',
        notSpamTooltip: 'Не спам — переместить во входящие',
        reportSpamTooltip: 'Пожаловаться на спам',
        createCalendarEvent: 'Создать событие в календаре',
        openNewWindow: 'Открыть в новом окне',
        exportEml: 'Экспорт как .eml',
        aiCategorize: 'Автокатегоризация AI',
        classifyResult: 'Категория',
        errorClassify: 'Ошибка автокатегоризации',
        labelsTitle: 'Метки',
        noLabelsHint: 'Нет меток — создайте в настройках',
        closePreview: 'Закрыть предпросмотр',
        snoozeSet: 'Напоминание установлено',
        errorSnooze: 'Ошибка установки напоминания',
        emailFrom: 'Письмо от:',
        eventCreated: 'Событие успешно создано в календаре!',
        errorCreatingEvent: 'Ошибка создания события',
        addAccount: '+ Добавить аккаунт',
        demo: 'Демо',
        emptyAction: 'Очистить',
        welcomeTitle: 'Добро пожаловать в ваш почтовый ящик',
        welcomeSubtitle: 'Подключите свой почтовый аккаунт, чтобы начать получать и отправлять сообщения. Вы можете подключить Gmail, Outlook или любой IMAP-аккаунт.',
        connectMailbox: 'Подключить почтовый ящик',
        connectHelpGuide: 'Гид по подключению Gmail',
        connectHelpWhatsapp: 'Помощь в WhatsApp',
        connectBannerTitle: 'Почтовый ящик ещё не подключён',
        connectBannerBody: 'Без подключённого ящика нельзя читать почту или пользоваться ИИ. Это займёт около минуты.',
        connectBannerCta: 'Подключить ящик',
        connectBannerDismiss: 'Позже',
        tryAgain: 'Попробовать снова',
        unread: 'Непрочитанные',
        attachmentsFilter: 'Файлы',
        advancedSearch: 'Расширенный поиск',
        dateFrom: 'С даты',
        dateTo: 'По дату',
        searchInBody: 'Искать в тексте',
        clearFilters: 'Очистить',
        paginationOf: 'из',
        firstPage: 'Первая страница',
        nextPage: 'Следующая страница',
        prevPage: 'Предыдущая страница',
        lastPage: 'Последняя страница',
        show: 'Показать:',
        autoRefresh: 'Автообновление',
        off: 'Выкл.',
        seconds30: '30 секунд',
        minute1: '1 минута',
        minutes2: '2 минуты',
        minutes5: '5 минут',
        createEventFromEmail: 'Создать событие в календаре из письма',
        eventTitle: 'Название',
        eventDescription: 'Описание',
        eventLocation: 'Место',
        eventStart: 'Начало',
        eventEnd: 'Окончание',
        createEventBtn: 'Создать событие',
        addMailAccount: 'Добавить почтовый аккаунт',
        connectToMailbox: 'Подключение к почтовому ящику',
        loginPrompt: 'Введите адрес эл. почты и пароль. Данные будут сохранены, чтобы не вводить их снова.',
        emailAddress: 'Адрес эл. почты',
        passwordLabel: 'Пароль',
        useAppPassword: 'Используйте пароль приложения (App Password, см. руководство ниже)',
        protocol: 'Протокол',
        localStorage: 'Локальное хранение',
        pop3Warning: 'Подходит для старых серверов. Ограничения: только INBOX, без синхронизации статуса прочтения, без поиска на сервере.',
        localCacheInfo: 'Сообщения будут сохранены локально для быстрой загрузки и офлайн-доступа.',
        addAndConnect: 'Добавить и подключить',
        connect: 'Подключить',
        connectGmail: 'Подключить Gmail',
        connectWorkspace: 'Подключить Google Workspace / IMAP-аккаунт',
        openAppPasswords: 'Открыть App Passwords в Google ↗',
        gmailAppPasswordInfo: 'Gmail требует пароль приложения (App Password) вместо обычного пароля.',
        gmailStep1: 'Перейдите на myaccount.google.com/security',
        gmailStep2: 'Включите двухэтапную аутентификацию, если она не активна',
        gmailStep3: 'Найдите "App Passwords" (пароли приложений)',
        gmailStep4: 'Создайте новый пароль приложения для "Mail" → скопируйте 16-значный код',
        gmailStep5: 'Вставьте код в поле «Пароль» выше (без пробелов)',
        workspaceInfo: 'Для Google Workspace (корпоративного домена) или других IMAP-аккаунтов:',
        workspaceStep1: '1. Убедитесь, что IMAP включён в настройках аккаунта',
        workspaceStep2: '2. Если включена двухэтапная аутентификация, создайте App Password',
        workspaceStep3: '3. Введите полный адрес эл. почты и пароль приложения',
        demoMode: 'Демо-режим',
        autoFill: 'Автозаполнение',
        sendFrom: 'Отправить с',
        sendAs: 'Отправить от имени',
        aiComposeDesc: 'Опишите, что вы хотите написать, и AI подготовит готовое к отправке письмо с темой.',
        aiComposePlaceholder: 'Опишите письмо, которое хотите отправить...',
        aiComposing: 'Составление...',
        aiComposeBtn: 'Составить письмо',
        aiGenerating: 'AI генерирует ответ...',
        aiGenerateReply: 'Сгенерировать ответ с AI',
        chooseTone: 'Выберите тон ответа',
        aiExample1: 'Составь трудовой договор для нашего нового сотрудника',
        aiExample2: 'Напиши письмо с итогами встречи на основе следующих пунктов:',
        aiExample3: 'Составь краткое содержание следующей статьи для рассылки:',
        aiExample4: 'Напиши профессиональное письмо о деловом партнёрстве',
        aiExample5: 'Составь ценовое предложение для клиента, запросившего консалтинговые услуги',
        aiExample6: 'Напиши вежливый ответ на жалобу клиента',
        aiExample7: 'Составь приглашение на конференцию / корпоративное мероприятие',
        aiExample8: 'Напиши письмо для продолжения общения после деловой встречи',
        trackingStats: 'Статистика отслеживания',
        trackingStatsTitle: 'Статистика отслеживания писем',
        noTrackingData: 'Данных отслеживания пока нет. Отправьте письмо с включённым "Отслеживанием открытий", чтобы увидеть статистику.',
        sentOn: 'Отправлено',
        openedOn: 'Открыто',
        openedTimes: 'Открыто {count} раз',
        pgpTooltip: 'Шифрование PGP — письмо будет зашифровано открытым ключом получателя',
        createFolder: 'Создать папку',
        deleteFolderWarning: 'Это действие удалит папку',
        deleteFolderConfirm: 'Вы уверены, что хотите удалить эту папку? Это действие нельзя отменить.',
        confirmDeleteFolder: 'Да, удалить папку',
        deleteMailAccount: 'Удалить почтовый аккаунт',
        confirmDeleteAccount: 'Вы уверены, что хотите удалить аккаунт',
        deleteAccountWarning: 'Аккаунт будет удалён со всех ваших устройств. Вы сможете добавить его снова в любое время.',
        confirmDelete: 'Подтвердить удаление',
        scheduleEmail: 'Запланировать отправку письма',
        scheduleDateLabel: 'Дата и время отправки',
        scheduling: 'Планирование...',
        scheduleSend: 'Запланировать отправку',
        undoSendMsg: 'Письмо будет отправлено через 5 секунд...',
        undoSend: 'Отменить отправку',
        allSearchSelected: 'Выбраны все {count} сообщений, соответствующих поиску "{query}".',
        cancelSelectAll: 'Отменить выбор всех',
        allPageSelected: 'Выбраны все {count} сообщений на этой странице.',
        selectAllSearchResults: 'Выбрать все {count} соответствующих сообщений',
        onboardingTitle: 'Добро пожаловать в Email Lion!',
        onboardingStep1: 'Добро пожаловать',
        onboardingStep2: 'Папки',
        onboardingStep3: 'Написание',
        onboardingStep4: 'Советы',
        onboarding1Title: 'Ваша почтовая система готова!',
        onboarding1Desc: 'Email Lion — это продвинутая почтовая система с профессиональными инструментами для управления вашими письмами. Давайте познакомимся с основными функциями.',
        onboarding2Title: 'Папки и организация',
        onboarding2Desc: 'Сбоку вы найдёте свои почтовые папки. Вы можете создавать новые папки, перетаскивать письма между папками и фильтровать их по умным категориям.',
        onboarding3Title: 'Написание письма',
        onboarding3Desc: 'Нажмите "Написать" или клавишу C на клавиатуре. Вы можете прикреплять файлы, планировать отправку, использовать шаблоны и отслеживать открытия писем.',
        onboarding4Title: 'Профессиональные советы',
        onboarding4Desc: '• Нажмите ?, чтобы посмотреть горячие клавиши\n• Нажмите /, чтобы перейти к поиску\n• Используйте быстрые фильтры для сортировки писем\n• Настройте личную подпись в настройках\n• Включите тёмную тему в верхнем меню',
        skip: 'Пропустить',
        letsStart: 'Начнём!',
        keyboardShortcuts: 'Горячие клавиши',
        kbCompose: 'Написать новое письмо',
        kbReply: 'Ответить на письмо',
        kbForward: 'Переслать письмо',
        kbDelete: 'Удалить выбранные',
        kbEscape: 'Закрыть / Снять выделение',
        kbSelectAll: 'Выбрать все',
        kbSearch: 'Перейти к поиску',
        kbHelp: 'Помощь — горячие клавиши',
        dragToReorder: 'Перетащите для изменения порядка',
        defaultAccount: 'По умолчанию',
        dragReorderHint: 'Перетащите для изменения порядка • Первый = по умолчанию',
        cannotConnectMailServer: 'Не удаётся подключиться к почтовому серверу. Проверьте правильность адреса эл. почты.',
        cannotTestConnection: 'Не удаётся проверить подключение.',
        connectionSaveFailed: 'Подключение проверено, но сохранить почтовый ящик не удалось. Попробуйте ещё раз.',
        testingConnection: 'Проверка подключения...',
        loadingOriginalAttachments: 'Загрузка {count} оригинальных вложений...',
        onDatePrefix: 'В ',
    },

    // ==================== SETTINGS ====================
    settings: {
        title: 'Настройки',
        tabGeneral: 'Общие',
        tabAi: 'AI-агент',
        tabSecurity: 'Безопасность',
        tabContacts: 'Контакты',
        tabSignatures: 'Подписи',
        tabTemplates: 'Шаблоны',
        tabRules: 'Правила',
        tabLabels: 'Метки',
        tabAlias: 'Псевдонимы',
        tabVacation: 'Автоответ',
        tabSendPermissions: 'Права отправки',
        tabReferral: 'Рефералы',
        viewMode: 'Режим просмотра',
        language: 'Язык',
        theme: 'Тема',
        notifications: 'Уведомления',
        changePassword: 'Смена пароля',
        currentPassword: 'Текущий пароль',
        newPassword: 'Новый пароль',
        confirmPassword: 'Подтверждение пароля',
        passwordChanged: 'Пароль успешно изменён',
        twoFactor: 'Двухфакторная аутентификация (2FA)',
        enable2FA: 'Включить 2FA',
        disable2FA: 'Отключить 2FA',
        pgpEncryption: 'Шифрование PGP',
        addContact: 'Добавить контакт',
        editContact: 'Редактировать контакт',
        deleteContact: 'Удалить контакт',
        contactName: 'Имя',
        contactEmail: 'Эл. почта',
        contactPhone: 'Телефон',
        contactCompany: 'Компания',
        noContacts: 'Нет контактов',
        addSignature: 'Добавить подпись',
        editSignature: 'Редактировать подпись',
        deleteSignature: 'Удалить подпись',
        defaultSignature: 'Подпись по умолчанию',
        signatureName: 'Название подписи',
        signatureContent: 'Содержимое подписи',
        noSignatures: 'Нет подписей',
        addTemplate: 'Добавить шаблон',
        editTemplate: 'Редактировать шаблон',
        deleteTemplate: 'Удалить шаблон',
        templateName: 'Название шаблона',
        templateSubject: 'Тема',
        templateBody: 'Содержимое',
        noTemplates: 'Нет шаблонов',
        addRule: 'Добавить правило',
        editRule: 'Редактировать правило',
        deleteRule: 'Удалить правило',
        noRules: 'Нет правил',
        ruleName: 'Название правила',
        ruleCondition: 'Условие',
        ruleAction: 'Действие',
        addLabel: 'Добавить метку',
        editLabel: 'Редактировать метку',
        deleteLabel: 'Удалить метку',
        noLabels: 'Нет меток',
        labelName: 'Название метки',
        labelColor: 'Цвет',
        vacationReply: 'Автоответ (отпуск)',
        vacationEnabled: 'Включено',
        vacationSubject: 'Тема ответа',
        vacationMessage: 'Текст ответа',
        vacationStart: 'Дата начала',
        vacationEnd: 'Дата окончания',
        saved: 'Успешно сохранено',
        errorSaving: 'Ошибка сохранения',
        referralTitle: 'Реферальная программа',
        referralCode: 'Ваш реферальный код',
        referralLink: 'Реферальная ссылка',
        copyLink: 'Копировать ссылку',
        linkCopied: 'Ссылка скопирована!',
        tabAdvanced: 'Дополнительно',
        referralInvitePrefix: 'Приглашайте друзей в Email Lion и получайте ',
        referralFreeMonth: 'бесплатный месяц',
        referralInviteSuffix: ' за каждого платящего друга!',
        referralYourCode: 'Ваш реферальный код',
        copied: 'Скопировано!',
        copyCode: 'Копировать код',
        referralsCount: 'Рефералы',
        rewardsCount: 'Вознаграждения',
        aiConfigSaved: 'Настройки AI успешно сохранены',
        aiConfigError: 'Ошибка сохранения настроек AI',
        viewSaved: 'Вид сохранён',
        newSignature: 'Новая подпись',
        signatureSaved: 'Подпись сохранена',
        signatureSaveError: 'Ошибка сохранения подписи',
        signatureDeleted: 'Подпись удалена',
        signatureDeleteError: 'Ошибка удаления подписи',
        categoryGeneral: 'Общие',
        templateNameRequired: 'Требуется название шаблона',
        templateSaved: 'Шаблон сохранён',
        templateSaveError: 'Ошибка сохранения шаблона',
        templateDeleted: 'Шаблон удалён',
        templateDeleteError: 'Ошибка удаления шаблона',
        emailRequired: 'Требуется эл. почта',
        contactSaved: 'Контакт сохранён',
        contactSaveError: 'Ошибка сохранения контакта',
        contactDeleteError: 'Ошибка удаления контакта',
        passwordsMismatch: 'Пароли не совпадают',
        passwordMinLength: 'Пароль должен содержать не менее 6 символов',
        passwordChangeError: 'Ошибка смены пароля',
        twoFASetupError: 'Ошибка настройки 2FA',
        twoFAEnabled: '2FA успешно включена!',
        twoFAVerifyError: 'Неверный код подтверждения',
        twoFADisabled: '2FA отключена',
        twoFADisableError: 'Ошибка отключения 2FA',
        pgpRequiredFields: 'Требуются имя, эл. почта и парольная фраза',
        pgpKeyCreated: 'Ключ PGP успешно создан',
        pgpKeyCreateError: 'Ошибка создания ключа',
        pgpPublicKeyImported: 'Открытый ключ импортирован',
        pgpImportError: 'Ошибка импорта ключа',
        pgpDeleteConfirm: 'Удалить этот ключ?',
        pgpKeyDeleted: 'Ключ удалён',
        deleteError: 'Ошибка удаления',
        delegationAdded: 'Право отправки добавлено',
        delegationAddError: 'Ошибка добавления права',
        delegationRemoved: 'Право удалено',
        delegationRemoveError: 'Ошибка удаления права',
        defaultVacationSubject: 'Я сейчас недоступен',
        vacationActivated: 'Автоответ включён',
        vacationDeactivated: 'Автоответ отключён',
        vacationSaveError: 'Ошибка сохранения автоответа',
        ruleNameRequired: 'Требуется название правила',
        ruleSaved: 'Правило сохранено',
        ruleSaveError: 'Ошибка сохранения правила',
        ruleDeleted: 'Правило удалено',
        ruleDeleteError: 'Ошибка удаления правила',
        labelSaved: 'Метка сохранена',
        labelSaveError: 'Ошибка сохранения метки',
        labelDeleted: 'Метка удалена',
        labelDeleteError: 'Ошибка удаления метки',
        scheduledCancelled: 'Запланированная отправка отменена',
        cancelError: 'Ошибка отмены',
        sessionTerminated: 'Сеанс завершён',
        sessionTerminateError: 'Ошибка отключения',
        allSessionsTerminated: 'Все остальные сеансы завершены',
        aliasEmailRequired: 'Требуется адрес псевдонима',
        aliasUpdated: 'Псевдоним обновлён',
        aliasAdded: 'Псевдоним добавлен',
        aliasDeleteConfirm: 'Удалить этот псевдоним?',
        aliasDeleted: 'Псевдоним удалён',
        mailboxShared: 'Доступ к ящику успешно предоставлен',
        revokeShareConfirm: 'Отозвать доступ?',
        selectMailboxError: 'Пожалуйста, выберите почтовый ящик из списка. Если ящиков нет, подключите его на странице Почты.',
        autoReplyAIEnabled: 'Автоответ AI включён!',
        autoReplyConfigSaved: 'Настройки автоответа сохранены',
        docUploadedSuccess: 'успешно загружен',
        uploadError: 'Ошибка загрузки',
        deleteDocConfirm: 'Удалить этот документ из базы знаний?',
        docDeleted: 'Документ удалён',
        contactExcluded: 'Контакт исключён',
        exclusionRemoved: 'Исключение удалено',
        contactsImported: 'Контакты импортированы',
        contactsImportError: 'Ошибка импорта контактов',
        contactsImportedVcard: 'Контакты импортированы из vCard',
        vcardImportError: 'Ошибка импорта vCard',
        backupStarted: 'Скачивание резервной копии началось...',
        backupCodesCopied: 'Резервные коды скопированы',
        secretCopied: 'Секрет скопирован',
        aiEngineTitle: 'Движок AI',
        aiEngineDesc: 'Выберите предпочитаемый движок AI для написания писем, ответов и автоответа.',
        defaultModelRecommended: 'Модель по умолчанию (рекомендуется)',
        saveAiPreferences: 'Сохранить настройки AI',
        globalPromptTitle: 'Системный промпт (глобальный)',
        globalPromptDesc: 'Задайте глобальный промпт для всех операций AI: написания писем, ответов и автоответа. Опишите ваш бизнес, тон и особые указания.',
        globalPromptPlaceholder: 'Пример: Я бизнес-консультант, мой тон профессиональный, но тёплый. Всегда обращайся по имени. Заканчивай словами \'С уважением, [моё имя]\'. Не обещай того, чего я не могу выполнить.',
        composePromptTitle: 'Свой промпт для написания новых писем',
        composePromptPlaceholder: 'Дополнительные инструкции для написания новых писем (пусто = использовать глобальный промпт)',
        replyPromptTitle: 'Свой промпт для ответов AI',
        replyPromptPlaceholder: 'Дополнительные инструкции для ответов на письма (пусто = использовать глобальный промпт)',
        autoReplyPromptTitle: 'Свой промпт для автоответа',
        autoReplyPromptPlaceholder: 'Дополнительные инструкции для автоответа (пусто = использовать глобальный промпт)',
        savePromptSettings: 'Сохранить настройки промптов',
        aiUsageAndBilling: 'Использование AI и биллинг',
        runsPerMonth: 'запусков в месяц',
        autoTopup: 'Автоматическое пополнение (Top-up), когда запуски заканчиваются',
        runsToAdd: 'Запусков добавить:',
        runs: 'запусков',
        recentUsage: 'Недавнее использование (30 дней):',
        dateColumn: 'Дата',
        actionColumn: 'Действие',
        providerColumn: 'Провайдер',
        quantityColumn: 'Количество',
        featureCompose: 'Написание',
        featureReply: 'Ответ',
        featureAutoReply: 'Автоответ',
        storageQuotaTitle: 'Квота хранилища',
        inUse: 'используется',
        allowed: 'доступно',
        storageUsedPercent: 'хранилища использовано',
        accountsCount: 'аккаунтов',
        contactsCountLabel: 'контактов',
        templatesCountLabel: 'шаблонов',
        signaturesCountLabel: 'подписей',
        emailSignatures: 'Почтовые подписи',
        noSignaturesDesc: 'Нет подписей. Создайте подпись, которая будет автоматически добавляться к вашим сообщениям.',
        defaultLabel: 'По умолчанию',
        mailHandlerTitle: 'Почтовое приложение по умолчанию',
        mailHandlerDesc: 'Сделайте Email Lion обработчиком ссылок mailto: по умолчанию на этом устройстве. Нажатие на любой адрес эл. почты откроет окно написания письма здесь.',
        mailHandlerButton: 'Установить по умолчанию',
        mailHandlerInstalled: 'Зарегистрировано в браузере ✓',
        mailHandlerSuccess: 'Запрос отправлен в браузер. Подтвердите запрос выше, чтобы включить.',
        mailHandlerError: 'Браузер отклонил запрос. Возможно, он уже подтверждён, или действие требует HTTPS.',
        mailHandlerNotSupported: 'Этот браузер не предоставляет API для автоматической регистрации протокола mailto:. Если приложение уже установлено, ОС должна предложить его автоматически. Иначе откройте страницу в Chrome / Edge / Firefox.',
        mailHandlerHttpsRequired: 'Для регистрации обработчика требуется защищённое соединение (HTTPS). Откройте страницу по адресу https://emaillion.net.',
        mailHandlerStandaloneTitle: 'Приложение установлено и работает ✓',
        mailHandlerStandaloneDesc: 'Поскольку приложение установлено, ваша операционная система управляет маршрутизацией ссылок mailto:. Чтобы сделать его по умолчанию: нажмите кнопку теста ниже или нажмите любую ссылку mailto: ВНЕ этого приложения. ОС покажет выбор приложений — выберите Email Lion и отметьте "Всегда".',
        mailHandlerTestTitle: '🔗 Тест',
        mailHandlerTestDesc: 'Нажатие этой кнопки открывает тестовую ссылку mailto:. Если всё настроено правильно, окно написания письма откроется здесь, в Email Lion. Иначе ОС покажет выбор приложений.',
        mailHandlerTestButton: 'Открыть тестовую ссылку mailto:',
        mailHandlerAndroidHint: 'Android: после установки PWA нажмите любую ссылку mailto: в другом приложении (браузер, WhatsApp и т.д.). Android покажет "Открыть с помощью" — выберите Email Lion и нажмите "Всегда". Чтобы изменить позже: Настройки системы ➤ Приложения ➤ Приложения по умолчанию ➤ Почтовое приложение.',
        mailHandlerIosHint: 'iOS: Apple не позволяет PWA заменять почтовое приложение по умолчанию. Используйте Email Lion через браузер или с главного экрана.',
        mailHandlerDesktopHint: 'Компьютер: нажатие "Установить по умолчанию" регистрирует Email Lion в браузере. Чтобы установить его по умолчанию на уровне ОС (Windows): Настройки ➤ Приложения ➤ Приложения по умолчанию ➤ Почта.',
        emailTemplates: 'Шаблоны писем',
        newTemplate: 'Новый шаблон',
        noTemplatesDesc: 'Нет шаблонов. Создайте шаблоны для быстрых ответов.',
        subjectPrefix: 'Тема:',
        noSubject: 'Без темы',
        exportCsv: 'Экспорт CSV',
        importCsv: 'Импорт CSV',
        exportVcard: 'Экспорт vCard (.vcf) — совместимо с Google / Apple / Outlook',
        importVcard: 'Импорт vCard (.vcf) — из Google / Apple / Outlook',
        searchPlaceholder: 'Поиск...',
        addButton: 'Добавить',
        contactsSavedAuto: 'Контакты сохраняются автоматически при отправке писем. Также можно добавить вручную.',
        importExportContacts: 'Импорт/экспорт контактов',
        csvDescription: 'Экспорт и импорт в табличном формате (Excel, Google Sheets)',
        vcardDescription: 'Стандартный формат контактов. Совместим с Google Contacts, Apple, Outlook',
        gmailMigrationHint: 'Переходите из Gmail? Перейдите в ',
        gmailMigrationHint2: ' > Экспорт > Выберите vCard > Импортируйте файл здесь',
        vacationActiveAlert: 'Автоответ активен — каждый, кто напишет вам, получит автоматический ответ.',
        messageSubject: 'Тема сообщения',
        vacationPlaceholder: 'Здравствуйте, я сейчас недоступен. Я свяжусь с вами в ближайшее время...',
        fromDate: 'С даты',
        toDate: 'По дату',
        sendToContactsOnly: 'Отправлять только моим контактам',
        saveAndActivate: 'Сохранить и включить',
        saveDisabled: 'Сохранить (отключено)',
        rulesAndFilters: 'Правила и фильтры',
        rulesDescription: 'Правила позволяют автоматически сортировать, помечать или удалять письма по заданным вами условиям.',
        newRule: 'Новое правило',
        noRulesDesc: 'Нет правил. Создайте новое правило для автоматической сортировки писем.',
        ruleDisabled: 'Отключено',
        contactsManagement: 'Управление контактами',
        contactsManagementDesc: 'Управление, импорт и экспорт контактов. Выберите вкладку "Общие" для полного редактирования.',
        goToGeneralSettings: 'Перейти в общие настройки для управления контактами',
        minChars: 'Минимум 6 символов',
        confirmNewPassword: 'Подтверждение нового пароля',
        changePasswordBtn: 'Сменить пароль',
        twoFactorDesc: 'Добавьте дополнительный уровень безопасности с помощью приложения-аутентификатора, например Google Authenticator.',
        twoFactorActive: '2FA включена и активна',
        backupCodesTitle: 'Резервные коды (сохраните их в надёжном месте!):',
        copyAll: 'Копировать все',
        disablePassword: 'Пароль для отключения',
        disable2FABtn: 'Отключить 2FA',
        scanQrCode: 'Отсканируйте код в приложении-аутентификаторе или введите секрет вручную.',
        scanWithAuthenticator: 'Отсканируйте с помощью Google Authenticator',
        secretManualEntry: 'Секрет (для ручного ввода)',
        enterCodeFromApp: 'Введите код из приложения',
        verifyAndEnable: 'Проверить и включить',
        enableTwoFactor: 'Включить двухфакторную аутентификацию',
        delegationTitle: 'Делегирование отправки',
        delegationDesc: 'Разрешите другим пользователям отправлять письма от вашего имени. Они смогут выбрать ваш адрес как отправителя при написании письма.',
        delegateEmailLabel: 'Эл. почта пользователя',
        sendAs: 'Отправить от имени',
        sendOnBehalf: 'Отправить по поручению',
        noDelegations: 'Нет активных прав отправки',
        pgpTitle: 'Шифрование почты (PGP)',
        pgpDesc: 'Управляйте ключами PGP для шифрования писем и цифровых подписей. Создавайте новые ключи или импортируйте открытые ключи контактов.',
        createNewKey: 'Создать новый ключ',
        pgpPassphrase: 'Парольная фраза шифрования',
        pgpPassphraseHelper: 'Запомните этот пароль — он понадобится для подписания и расшифровки',
        createKey: 'Создать ключ',
        importPublicKey: 'Импортировать открытый ключ:',
        importKey: 'Импортировать ключ',
        privateAndPublic: 'Закрытый+открытый',
        publicKey: 'Открытый',
        fingerprint: 'Отпечаток',
        noPgpKeys: 'Ключи PGP не настроены',
        labelsTitle: 'Метки',
        addLabelBtn: 'Добавить метку',
        noLabelsAlert: 'Метки ещё не созданы. Метки позволяют категоризировать письма по цветам.',
        editLabelTitle: 'Редактировать метку',
        newLabelTitle: 'Новая метка',
        labelNameField: 'Название метки',
        colorLabel: 'Цвет:',
        preview: 'Предпросмотр',
        scheduledEmails: 'Запланированные письма',
        refreshBtn: 'Обновить',
        noScheduledEmails: 'Нет запланированных писем. Вы можете запланировать отправку из окна нового сообщения.',
        recipient: 'Получатель',
        scheduledFor: 'Запланировано на',
        statusPending: 'В ожидании',
        statusSent: 'Отправлено',
        statusCancelled: 'Отменено',
        statusFailed: 'Не удалось',
        cancelSend: 'Отменить отправку',
        noSubjectLabel: '(Без темы)',
        aiAutoReplyTitle: 'Умный автоответ AI',
        active: 'Активен',
        inactive: 'Неактивен',
        selectMailbox: 'Выберите почтовый ящик для включения автоответа:',
        noMailboxes: 'Нет подключённых почтовых ящиков. Подключите ящик на странице Почты, чтобы включить автоответ.',
        betaInfo: 'Автоответ будет отвечать на входящие письма на основе вашего промпта и базы знаний. Только настоящие письма — не спам, реклама или рассылки.',
        activeMailbox: 'Активный ящик:',
        promptSetup: 'Промпт и настройка',
        promptSetupDesc: 'Опишите, кто вы, ваш бизнес и как отвечать. Чем детальнее, тем лучше ответы.',
        toneLabel: 'Тон',
        toneProfessional: 'Профессиональный',
        toneFriendly: 'Дружелюбный',
        toneBrief: 'Краткий',
        toneFormal: 'Официальный',
        languageLabel: 'Язык',
        hebrew: 'Иврит',
        maxLengthWords: 'Макс. длина (слов)',
        delayMinutes: 'Задержка (минут)',
        knowledgeBase: 'База знаний',
        documentsCount: 'документов',
        knowledgeBaseDesc: 'Загрузите документы, которые AI будет использовать для точных ответов. Поддерживаются: TXT, CSV, JSON, HTML, MD.',
        uploadDocument: 'Загрузить документ',
        maxDocSize: 'Максимум 50KB на документ',
        noDocuments: 'Нет документов. Загрузите документы для более точных ответов AI.',
        emailFiltering: 'Фильтрация писем',
        skipSpam: 'Пропускать спам',
        skipPromotions: 'Пропускать рекламу',
        skipNewsletters: 'Пропускать рассылки',
        skipNoreply: 'Пропускать адреса no-reply',
        skipAutoReplies: 'Пропускать автоответы',
        onlyKnownContacts: 'Отвечать только известным контактам',
        startHour: 'Час начала',
        endHour: 'Час окончания',
        activeDays: 'Активные дни',
        maxRepliesPerDay: 'Макс. ответов в день',
        maxRepliesPerSender: 'Макс. на отправителя',
        exclusionsTitle: 'Исключения',
        exclusionsDesc: 'Контакты, которые не будут получать автоответы — вы ответите им вручную.',
        exclusionName: 'Имя (необязательно)',
        exclusionReason: 'Причина',
        replyLog: 'Журнал ответов',
        sentCount: 'Отправлено',
        skippedCount: 'Пропущено',
        failedCount: 'Не удалось',
        excludedCount: 'Исключено',
        avgTime: 'Среднее время',
        noLogEntries: 'Записей пока нет.',
        senderColumn: 'Отправитель',
        reasonResponseColumn: 'Причина / Ответ',
        logStatusSent: 'Отправлено',
        logStatusSkipped: 'Пропущено',
        logStatusExcluded: 'Исключено',
        logStatusFailed: 'Не удалось',
        saving: 'Сохранение...',
        saveAutoReplySettings: 'Сохранить настройки автоответа',
        backupExport: 'Резервное копирование и экспорт ящика',
        backupDesc: 'Скачайте все письма из выбранной папки в виде ZIP-файла. Каждое письмо сохраняется в формате .eml.',
        inboxFolder: 'Входящие',
        sentFolder: 'Отправленные',
        draftsFolder: 'Черновики',
        trashFolder: 'Корзина',
        spamFolder: 'Спам',
        downloadBackup: 'Скачать резервную копию (ZIP)',
        aliasAddresses: 'Адреса-псевдонимы',
        addAlias: 'Добавить псевдоним',
        noAliases: 'Псевдонимы не настроены. Добавьте адреса, чтобы отправлять с них письма.',
        noDisplayName: 'Без отображаемого имени',
        sharedMailboxes: 'Общие почтовые ящики',
        shareMailbox: 'Поделиться ящиком',
        sharedWithMe: 'Доступны мне:',
        myShares: 'Мои общие ящики:',
        permissionRead: 'Чтение',
        permissionWrite: 'Запись',
        permissionAdmin: 'Администратор',
        sharedWith: 'Доступен для:',
        permissionLabel: 'Право:',
        noSharedMailboxes: 'Нет общих ящиков. Нажмите "Поделиться ящиком", чтобы поделиться с членами команды.',
        shareMailboxDialog: 'Поделиться почтовым ящиком',
        shareMailboxDesc: 'Выберите почтовый ящик, которым хотите поделиться, и пользователя.',
        mailboxToShare: 'Ящик для предоставления доступа',
        noConnectedMailboxes: 'Нет подключённых ящиков',
        shareWithUser: 'Поделиться с пользователем',
        searchUserPlaceholder: 'Поиск пользователя по имени или эл. почте...',
        noUsersFound: 'Пользователи не найдены',
        loadingUsers: 'Загрузка пользователей...',
        noName: 'Без имени',
        adminRole: 'Администратор',
        userRole: 'Пользователь',
        permissionLevel: 'Уровень доступа',
        readOnlyDesc: 'Только чтение — просмотр сообщений',
        readWriteDesc: 'Чтение + запись — отправка сообщений',
        fullAdminDesc: 'Полный администратор — включая настройки',
        shareBtn: 'Поделиться',
        activeSessions: 'Активные сеансы',
        disconnectAll: 'Отключить все',
        noSessions: 'Активных сеансов не зафиксировано.',
        deviceBrowser: 'Устройство / Браузер',
        ipAddress: 'IP-адрес',
        lastActivity: 'Последняя активность',
        createdColumn: 'Создан',
        unknown: 'Неизвестно',
        disconnectSession: 'Завершить сеанс',
        editAliasTitle: 'Редактировать псевдоним',
        newAliasTitle: 'Добавить новый псевдоним',
        aliasEmailField: 'Адрес эл. почты',
        displayNameField: 'Отображаемое имя',
        displayNamePlaceholder: 'Имя, отображаемое получателям',
        setAsDefault: 'Установить как адрес по умолчанию',
        ruleIfPrefix: 'Если',
        conditionFrom: 'От',
        conditionTo: 'Кому',
        conditionSubject: 'Тема',
        conditionHasAttachment: 'Есть вложение',
        conditionContains: 'Содержит',
        conditionEquals: 'Равно',
        conditionStartsWith: 'Начинается с',
        conditionEndsWith: 'Заканчивается на',
        conditionYes: 'Да',
        actionMoveToFolder: 'Переместить в папку',
        actionMarkRead: 'Пометить как прочитанное',
        actionStar: 'Пометить звездой',
        actionDelete: 'Удалить',
        actionForward: 'Переслать на адрес',
        valuePlaceholder: 'Значение...',
        folderNamePlaceholder: 'Название папки (например: Спам, Архив)',
        forwardPlaceholder: 'Адрес пересылки',
        ruleActive: 'Правило активно',
        conditionLabel: 'Условие',
        actionLabel: 'Действие',
        sigDialogPlaceholder: 'Напишите вашу подпись здесь...',
        templateContentPlaceholder: 'Напишите содержимое шаблона...',
        category: 'Категория',
        subjectOptional: 'Тема (необязательно)',
        notesLabel: 'Заметки',
        newContactTitle: 'Новый контакт',
        popupView: 'Всплывающее окно',
        popupViewDesc: 'Нажатие на письмо открывает диалог.',
        pageView: 'Отдельная страница (Gmail)',
        pageViewDesc: 'Нажатие на письмо открывает полную страницу.',
        previewView: 'Панель предпросмотра (Outlook)',
        previewViewDesc: 'Нажатие показывает предпросмотр сбоку.',
        recommended: 'Рекомендуется',
        fast: 'Быстро',
        dayNamesShort: ['В', 'П', 'В', 'С', 'Ч', 'П', 'С'],
        betaModePrefix: 'Режим BETA:',
        webmailPage: 'Почта',
        promptExample: 'Пример:\nЯ Йоси, генеральный директор Emilion. Мы компания по разработке и дизайну сайтов.\n\nЦены:\n- Лендинг: $800-$2,200\n- Интернет-магазин: $2,200-$4,000\n- Приложение: от $5,500\n\nПожалуйста, отвечай на вопросы клиентов профессионально и приветливо.',
        dangerZone: 'Опасная зона',
        deleteAccountTitle: 'Удаление аккаунта',
        deleteAccountDesc: 'Удаление аккаунта необратимо. Все ваши данные будут помечены как удалённые, и вы выйдете из системы.',
        deleteAccountBtn: 'Удалить аккаунт',
        deleteIrreversible: 'Это действие полностью необратимо. Ваш аккаунт будет помечен как удалённый, и вы не сможете войти снова.',
        deleteConfirmQuestion: 'Вы уверены, что хотите удалить свой аккаунт?',
        deleteAfterInfo: 'После удаления вы автоматически выйдете из системы. Администратор системы будет уведомлён.',
        deleteTypeToConfirm: 'Для подтверждения введите в поле ниже:',
        deleteTypeLabel: 'Введите для подтверждения',
        deleteContinue: 'Продолжить',
        deleteInProgress: 'Удаление...',
        deleteConfirmBtn: 'Подтвердить удаление',
        deleteAccountError: 'Ошибка удаления аккаунта',
        connectionTestSubject: 'Проверка подключения Email Lion',
        connectionTestBody: 'Если это окно открылось в Email Lion — настройка работает.',
    },

    // ==================== DASHBOARD PAGE ====================
    dashboard: {
        title: 'Панель управления',
        greeting: 'Здравствуйте',
        dateLocale: 'ru-RU',
        organizations: 'Организации',
        activeMailboxes: 'Активные ящики',
        domains: 'Домены',
        storageUsed: 'Использовано хранилища',
        activityTrend: 'Активность — последние 7 дней',
        activityByType: 'Активность по типам (30 дней)',
        storageByOrg: 'Хранилище по организациям',
        usersByRole: 'Пользователи по ролям',
        mailboxStatus: 'Статус почтовых ящиков',
        recentActivity: 'Недавняя активность',
        noData: 'Нет данных',
        noDataYet: 'Данных пока нет',
        noDataToShow: 'Нет данных для отображения',
        system: 'Система',
        storageUsedLabel: 'Использовано',
        storageQuotaLabel: 'Квота',
        connectedAccounts: 'подключено',
        hostedMailboxes: 'размещено',
        totalMailboxes: 'из {{total}} всего',
        verifiedDomains: 'подтверждено',
        actionsLabel: 'Действия',
        roles: {
            super_admin: 'Суперадминистратор',
            org_admin: 'Администратор организации',
            multi_org_admin: 'Администратор нескольких организаций',
            user: 'Пользователь',
        },
        actions: {
            login: 'Вход',
            send_email: 'Отправка письма',
            create_user: 'Создание пользователя',
            update_user: 'Обновление пользователя',
            delete_user: 'Удаление пользователя',
            create_org: 'Создание организации',
            create_domain: 'Создание домена',
            create_mailbox: 'Создание ящика',
        },
    },

    // ==================== MODULES / TRIAL ====================
    modules: {
        automations: {
            title: 'AI-автоматизации почты',
            tagline: 'Анализируйте входящие письма, извлекайте данные из файлов, создавайте задачи автоматически.',
            bullets: [
                'AI составляет сводки, категоризирует и отвечает на каждое релевантное письмо',
                'Ежедневный отчёт по расписанию включает задачи, письма и оповещения календаря',
                'Извлечение вложений и отправка в Drive/Dropbox с умной архивацией',
            ],
            trialDescription: 'В пробный период вы можете создать одну автоматизацию и запустить её до 10 раз.',
            gentleNudge: 'Начните с одной автоматизации на реальном письме. Когда увидите результаты, обновление откроет больше автоматизаций и непрерывные запуски.',
            primaryCta: 'Перейти на полные автоматизации',
            secondaryCta: 'Сначала подключите почтовый ящик',
        },
        ai_agent: {
            title: 'Личный AI-агент',
            tagline: 'Свободный чат с AI, который знает вашу почту, календарь и задачи.',
            bullets: [
                'Спрашивайте на естественном языке и получайте выполненные действия (отправить, классифицировать, архивировать)',
                'Подключается к Green Invoice, находит счета, составляет сводки писем',
                'Хранит личную память и шаблоны промптов, которые вы создаёте сами',
            ],
            trialDescription: 'В пробный период вы получаете 10 бесплатных диалогов.',
            gentleNudge: 'Попробуйте спросить о своих письмах, календаре или автоматизациях. В пробный период кредиты не списываются; после — вы продолжаете с пакетом кредитов.',
            primaryCta: 'Купить кредиты',
            secondaryCta: 'Подключите почтовый ящик для лучших ответов',
        },
        filing: {
            title: 'Умная архивация документов',
            tagline: 'Каждый документ, пришедший по почте, сам попадает в нужную папку в Drive или Dropbox.',
            bullets: [
                'AI определяет тип документа (счёт / договор / квитанция) и архивирует его автоматически',
                'Безопасное подключение по OAuth к Google Drive и Dropbox',
                'Собственные правила архивации — по отправителю, ключевым словам, содержимому',
            ],
            trialDescription: 'В пробный период вы можете создать одно правило и сохранить до 10 документов.',
            gentleNudge: 'Вы можете создать облачное подключение и первое правило для пробы. После нескольких успешных сохранений полный тариф откроет непрерывную архивацию.',
            primaryCta: 'Перейти на полную архивацию',
            secondaryCta: 'Создайте первое правило',
        },
        proposals: {
            title: 'Система коммерческих предложений',
            tagline: 'Профессионально оформленные предложения, онлайн-утверждение и цифровая подпись — даже на мобильном.',
            bullets: [
                'Быстрое создание из шаблона, автоматический расчёт НДС и скидок',
                'Клиент утверждает и подписывает онлайн — больше никаких PDF для возврата по почте',
                'Встроенное получение первоначального платежа, включая квитанцию',
            ],
            trialDescription: 'В пробный период вы можете создать до 10 предложений.',
            gentleNudge: 'Создайте несколько реальных предложений и посмотрите, как клиенты утверждают их онлайн. После пробного периода продолжайте с тарифом или модулем предложений.',
            primaryCta: 'Перейти на безлимитные предложения',
            secondaryCta: 'Создать пример предложения',
        },
        trialEnded: 'Пробный период завершён — обновите тариф',
        trialMode: 'Пробный режим',
        trialRemaining: 'Проба: осталось {remaining}/{max}',
        trialAlertText: 'в пробном режиме — у вас осталось {remaining} из {max} использований.',
        upgradeBtn: 'Обновить',
        moduleFallback: 'Модуль',
        viewOnlyMode: 'Режим только для просмотра',
        upgradeNow: 'Обновите сейчас для полного доступа',
        getQuote: 'Получить расчёт',
        capReachedTitle: 'Вы достигли лимита пробного периода',
        trialEndedTitle: 'Пробный период завершён',
        trialExhaustedMsg: 'Вы исчерпали пробный лимит этого модуля. Обновите тариф, чтобы получить полный доступ и разблокировать все возможности.',
        trialAutomationCapMsg: 'В пробном режиме можно создать только одну автоматизацию. Обновление открывает неограниченные автоматизации.',
        trialRuleCapMsg: 'В пробном режиме можно создать только одно правило. Обновление открывает неограниченные правила.',
        upgradeNowBtn: 'Обновить сейчас',
    },

    // ==================== UPGRADE PROMPT ====================
    upgrade: {
        upgradePlan: 'Обновить тариф',
        choosePlan: 'Выберите тариф',
        perMailbox: '/ящик',
        mailboxCount: 'Количество ящиков:',
        billingCycle: 'Период оплаты',
        monthly: 'Ежемесячно',
        yearly: 'Ежегодно',
        perMonthShort: '/мес',
        yearlySavings: '(экономия 20%)',
        platformFee: 'Плата за платформу',
        mailboxes: 'ящиков',
        volumeDiscount: 'Скидка за объём ({percent}%)',
        vat: 'НДС (18%)',
        totalYearlyVat: 'Итого за год с НДС',
        totalMonthlyVat: 'Итого за месяц с НДС',
        perMonthOnly: '= всего ₪{amount} в месяц (с НДС)',
        payNow: 'Оплатить сейчас',
        paymentTitle: 'Оплата',
        preparingPayment: 'Подготовка страницы оплаты...',
        paymentFailed: 'Оплата не удалась. Попробуйте ещё раз.',
        noPaymentLink: 'Ссылка на оплату не получена',
        paymentError: 'Ошибка создания платежа',
        freePlanBanner: 'Вы на бесплатном тарифе — перейдите на платный тариф, чтобы получить больше ящиков, хранилища и полные модули',
        nearLimitBanner: 'Вы достигли {percent}% квоты — обновите тариф, чтобы избежать блокировки',
        upgradeNow: 'Обновить сейчас',
        getQuote: 'Получить расчёт',
        getDetailedQuote: 'Получить подробный расчёт',
        upgradeToPaid: 'Перейти на платный тариф',
        nearPlanLimit: 'Близко к лимиту тарифа',
        mailboxesUsage: 'Ящики: {used}/{max} ({percent}%)',
        storageUsage: 'Хранилище: {used} GB / {max} GB ({percent}%)',
    },

    // ==================== ATTACHMENTS ====================
    attachments: {
        attachedFiles: 'Вложения',
        file: 'Файл',
        clickToView: 'Нажмите для просмотра',
        clickToDownload: 'Нажмите для скачивания',
        download: 'Скачать',
        downloadError: 'Ошибка скачивания файла',
        loadError: 'Ошибка загрузки файла',
        cannotLoadFile: 'Не удаётся загрузить файл',
        tryDownload: 'Попробуйте скачать',
        downloadFile: 'Скачать файл',
        downloadFileShort: 'Скачать файл',
        loadingFile: 'Загрузка файла...',
        loadingEditView: 'Загрузка режима редактирования...',
        loading: 'Загрузка...',
        pdfRenderError: 'Не удаётся загрузить предпросмотр PDF. Вы можете рисовать на белом фоне — подписи будут сохранены в файле.',
        pdfNotSupported: 'Ваш браузер не поддерживает встроенный просмотр PDF',
        ofTotal: 'из',
        finishEditing: 'Завершить редактирование',
        editAnnotate: 'Редактировать / Аннотировать',
        signature: 'Подпись',
        saveSignedPdf: 'Сохранить подписанный PDF',
        print: 'Печать',
        replyWithFile: 'Ответить с файлом',
        drawTool: 'Инструмент рисования',
        draw: 'Рисовать',
        addText: 'Добавить текст',
        text: 'Текст',
        handTool: 'Инструмент «рука» (перетаскивание подписи)',
        move: 'Переместить',
        undoLast: 'Отменить последнее',
        clearAll: 'Очистить всё',
        eSignature: 'Электронная подпись',
        drawSignatureTab: 'Нарисовать подпись',
        savedSignaturesTab: 'Сохранённые подписи',
        uploadImageTab: 'Загрузить изображение',
        drawSignatureHint: 'Нарисуйте вашу подпись в поле ниже. Она будет сохранена как прозрачный PNG.',
        clear: 'Очистить',
        signatureNamePlaceholder: 'Название подписи (необязательно)',
        saveSignatureTooltip: 'Сохранить подпись для будущего использования',
        save: 'Сохранить',
        noSavedSignatures: 'Нет сохранённых подписей',
        drawNewSignature: 'Нарисовать новую подпись',
        signatureDefault: 'Подпись',
        setAsDefault: 'Установить по умолчанию',
        deleteSig: 'Удалить',
        uploadSignatureImage: 'Загрузить изображение подписи',
        uploadHint: 'Рекомендуется прозрачный PNG. Другие изображения (JPG, WEBP) будут преобразованы автоматически.',
        chooseImage: 'Выбрать изображение',
        imageSavedToAccount: 'Изображение будет сохранено в вашем аккаунте для повторного использования',
        cancel: 'Отмена',
        placeSignatureOnDoc: 'Разместить подпись на документе',
        clickSigToPlace: 'Нажмите на подпись, чтобы разместить её на документе',
        drawSignatureFirst: 'Пожалуйста, сначала нарисуйте подпись',
        signatureSaved: 'Подпись успешно сохранена',
        signatureSaveError: 'Ошибка сохранения подписи',
        chooseImageFile: 'Пожалуйста, выберите файл изображения',
        imageSavedAsSignature: 'Изображение сохранено как подпись',
        imageSaveError: 'Ошибка сохранения изображения',
        importedSignature: 'Импортированная подпись',
        signatureDeleted: 'Подпись удалена',
        signatureDeleteError: 'Ошибка удаления подписи',
        signedFileSaved: 'Подписанный файл успешно сохранён',
        signedFileSaveError: 'Ошибка сохранения аннотированного PDF',
        signedFileAttached: 'Подписанный файл прикреплён к ответу',
        fileAttached: 'Файл прикреплён к ответу',
        attachError: 'Ошибка прикрепления файла',
        noSubject: '(без темы)',
        emailFrom: 'От:',
        emailTo: 'Кому:',
        emailCc: 'Копия:',
        emailDate: 'Дата:',
        emptyEmailBody: 'Вложенное письмо пустое.',
        nestedAttachments: 'Файлы внутри письма',
        csvPreviewHint: 'Показано {shown} из {total} строк',
        noCalendarEvents: 'В файле календаря нет событий',
        untitledEvent: 'Событие без названия',
        eventWhen: 'Когда',
        eventWhere: 'Где',
        noContacts: 'Контакты не найдены',
        unnamedContact: 'Контакт без имени',
        officeNeedsDownload: 'Файлы Word / Excel / PowerPoint открываются после скачивания, как в большинстве почтовых программ.',
        msgNeedsDownload: 'Файлы Outlook (.msg) нельзя открыть в браузере. Скачайте файл или попросите отправителя прислать .eml.',
    },

    // ==================== AI AGENT ====================
    aiAgent: {
        title: 'Личный AI-агент',
        subtitle: 'Задавайте вопросы и выполняйте задачи с письмами, календарём, автоматизациями и архивацией. Чувствительные действия ожидают утверждения.',
        subtitleShort: 'Задавайте вопросы и выполняйте задачи с письмами, календарём, автоматизациями и архивацией.',
        conversations: 'Диалоги',
        noConversations: 'Диалогов пока нет',
        newConversation: 'Новый диалог',
        deleteConversationAria: 'Удалить диалог',
        deleteConversationConfirm: 'Удалить этот диалог из истории?',
        conversationDeleted: 'Диалог удалён из истории',
        errorLoadConversations: 'Ошибка загрузки диалогов агента',
        errorLoadConversation: 'Ошибка загрузки диалога',
        errorDeleteConversation: 'Ошибка удаления диалога',
        errorSendMessage: 'Ошибка отправки сообщения агенту',
        errorLoadGreenInvoice: 'Ошибка загрузки настроек Green Invoice',
        errorLoadMemories: 'Ошибка загрузки памяти агента',
        errorLoadPending: 'Ошибка загрузки ожидающих действий',
        errorLoadUsage: 'Ошибка загрузки отчётов об использовании и затратах',
        errorLoadBilling: 'Ошибка загрузки настроек биллинга',
        greenInvoiceSaved: 'Настройки Green Invoice успешно сохранены',
        errorSaveGreenInvoice: 'Ошибка сохранения настроек Green Invoice',
        connectionTestFailed: 'Проверка подключения не удалась',
        memorySaved: 'Память успешно сохранена',
        errorSaveMemory: 'Ошибка сохранения памяти',
        memoryDeleted: 'Память удалена',
        errorDeleteMemory: 'Ошибка удаления памяти',
        billingSaved: 'Настройки биллинга сохранены',
        errorSaveBilling: 'Ошибка сохранения настроек биллинга',
        errorCreatePayment: 'Ошибка создания платежа за пакет кредитов',
        paymentsSynced: 'Платежи проверены, и баланс кредитов обновлён, если оплата была завершена',
        errorSyncPayments: 'Ошибка синхронизации платежа за кредиты',
        topupEnabled: 'Автоматическое пополнение включено. Открывается первоначальный платёж, чтобы пополнить баланс сейчас.',
        errorSaveTopup: 'Ошибка сохранения настроек Top-up',
        templateNeedsNameAndText: 'Пожалуйста, укажите название и текст шаблона',
        templateUpdated: 'Шаблон обновлён',
        templateSaved: 'Шаблон сохранён',
        errorSaveTemplate: 'Ошибка сохранения шаблона',
        deleteTemplateConfirm: 'Удалить этот шаблон?',
        errorDeleteTemplate: 'Ошибка удаления шаблона',
        errorConfirmation: 'Ошибка обработки подтверждения',
        doneFallback: 'Готово.',
        actionApproved: 'Действие утверждено и выполнено.',
        actionCancelled: 'Действие отменено и не выполнено.',
        templatesBtn: 'Шаблоны',
        pendingActionsBtn: 'Ожидающие действия',
        pendingActionsTooltip: 'Ожидающие действия ({count})',
        settingsBtn: 'Настройки',
        personalScopeChip: 'Только личный Scope',
        approvalChip: 'Утверждение перед действиями записи',
        availableCredits: 'Доступные кредиты: {amount}',
        greenInvoiceConnectedChip: 'Green Invoice подключён',
        questionTemplates: 'Шаблоны вопросов',
        howCanIHelp: 'Чем могу помочь?',
        examplesText: 'Например: "Найди письма от клиента Дани", "Проанализируй мой календарь на этой неделе", "Полностью синхронизируй календарь с Google", "Создай автоматизацию для счетов от поставщиков" или "Организуй мои файлы в Drive".',
        pendingApprovalTitle: 'Действия, ожидающие утверждения',
        pendingApprovalText: '{count} действий из всех диалогов агента ожидают вашего утверждения.',
        openApprovalBoard: 'Открыть доску утверждений',
        toolResult: 'Результат инструмента:',
        purchase: 'Купить',
        enableTopup: 'Включить Top-up',
        actionApprovalRequired: 'Требуется утверждение действия',
        toolLabel: 'Инструмент:',
        approveAndRun: 'Утвердить и выполнить',
        cancelBtn: 'Отмена',
        agentThinking: 'Агент думает...',
        inputPlaceholder: 'Скажите агенту, что вы хотите сделать...',
        templatesDialogTitle: 'Шаблоны вопросов для агента',
        newTemplate: 'Новый шаблон',
        templatesDialogHint: 'Выберите шаблон, чтобы скопировать его текст в поле промпта. Вы также можете создавать личные шаблоны для повторного использования.',
        editTemplate: 'Редактировать шаблон',
        category: 'Категория',
        templateName: 'Название шаблона',
        templateText: 'Текст шаблона',
        updateTemplate: 'Обновить шаблон',
        saveTemplate: 'Сохранить шаблон',
        myTemplates: 'Мои шаблоны',
        noCustomTemplates: 'Вы ещё не создали личные шаблоны. Нажмите "Новый шаблон", чтобы добавить первый.',
        editTemplateAria: 'Редактировать шаблон',
        deleteTemplateAria: 'Удалить шаблон',
        builtinTemplates: 'Встроенные шаблоны',
        customCategory: 'Личные',
        settingsTitle: 'Настройки AI-агента',
        tabMemories: 'Память',
        tabApprovals: 'Действия на утверждение',
        tabUsage: 'Использование и биллинг',
        tabInvoices: 'Счета',
        invoicesTitle: 'Счета',
        invoicesHint: 'Введите учётные данные API, чтобы агент мог искать документы и отчёты в Green Invoice. Ключ и секрет хранятся в зашифрованном виде.',
        saveScope: 'Scope сохранения',
        scopeMyUserOnly: 'Только мой пользователь',
        scopeOrg: 'Вся организация',
        existingConnection: 'Существующее подключение: ключ {key} · секрет {secret}',
        savedLabel: 'Сохранено',
        enterApiKey: 'Введите API Key',
        enterApiSecret: 'Введите API Secret',
        keepEmptyKey: 'Оставьте пустым, чтобы сохранить существующий ключ.',
        keepEmptySecret: 'Оставьте пустым, чтобы сохранить существующий секрет.',
        testConnection: 'Проверить подключение',
        memoriesTitle: 'Управление личной памятью',
        memoryType: 'Тип',
        memoryKey: 'Ключ',
        memoryValue: 'Значение памяти',
        updateMemory: 'Обновить память',
        addMemory: 'Добавить память',
        cancelEdit: 'Отменить редактирование',
        noMemories: 'Сохранённой памяти пока нет.',
        updatedAtLabel: 'Обновлено',
        noPendingActions: 'Сейчас нет действий, ожидающих утверждения.',
        conversationLabel: 'Диалог:',
        usageTitle: 'Кредиты, использование и затраты AI',
        creditBalance: 'Баланс кредитов',
        availableOf: 'Доступно {available} из {total}',
        lowBalance: 'Низкий баланс',
        refreshCredits: 'Обновить кредиты',
        syncPayment: 'Синхронизировать платёж',
        reportScope: 'Scope отчёта',
        scopeMyUser: 'Мой пользователь',
        refreshReport: 'Обновить отчёт',
        requestsLabel: 'Запросы',
        tokensLabel: 'Токены',
        costLabel: 'Стоимость',
        recommendedCharge: 'Рекомендуемая плата',
        expectedProfit: 'Ожидаемая прибыль',
        billingSettingsTitle: 'Настройки биллинга и прибыли',
        billingScope: 'Scope биллинга',
        markupPercent: 'Наценка прибыли (%)',
        saveMarkup: 'Сохранить наценку',
        markupHint: 'Рекомендуемая плата рассчитывается из фактической стоимости AI плюс заданная наценка прибыли.',
        buyCreditsTitle: 'Купить кредиты AI-агента',
        syncPaymentAndUpdate: 'Синхронизировать платёж и обновить баланс',
        promptRoles: ['Руководство', 'Финансы', 'Обслуживание клиентов', 'Продажи'],
        promptTemplates: [
            { role: 'Руководство', label: 'Ежедневная сводка', prompt: 'Составь сводку того, что произошло сегодня в моих письмах, календаре и автоматизациях, и предложи следующие 5 действий по срочности.' },
            { role: 'Руководство', label: 'Отчёт о статусе', prompt: 'Подготовь короткий отчёт о состоянии работы на этой неделе: клиенты, ожидающие ответа, предстоящие встречи и автоматизации, требующие проверки.' },
            { role: 'Руководство', label: 'Проверка возможностей', prompt: 'Проверь, какие возможности мне сейчас доступны: письма, календарь, автоматизации, архивация и облачные подключения.' },
            { role: 'Руководство', label: 'Подготовка задач', prompt: 'Подготовь список задач для дальнейшей работы на основе моих последних писем, не выполняя никаких действий до моего утверждения.' },
            { role: 'Руководство', label: 'Улучшение процессов', prompt: 'Просмотри список моих автоматизаций и предложи 3 практических улучшения для сокращения ручной работы.' },
            { role: 'Финансы', label: 'Счета в почте', prompt: 'Найди в моих письмах сообщения на тему "счёт" и составь сводку 10 самых важных результатов.' },
            { role: 'Финансы', label: 'Green Invoice', prompt: 'Найди в Green Invoice документы, связанные с клиентом "Дани", и составь сводку с номером документа, датой, статусом и суммой.' },
            { role: 'Финансы', label: 'Открытые документы', prompt: 'Найди в Green Invoice открытые или неоплаченные документы и упорядочи их по срочности.' },
            { role: 'Финансы', label: 'Финансовый отчёт', prompt: 'Подготовь короткий отчёт из Green Invoice по документам за прошлый месяц: сколько найдено, какие клиенты выделяются и что требует внимания.' },
            { role: 'Финансы', label: 'Автоматизация счетов', prompt: 'Создай новую автоматизацию, которая обнаруживает письма о счетах, извлекает сумму, поставщика и дату и отправляет результат на мою почту. Запроси утверждение перед созданием.' },
            { role: 'Обслуживание клиентов', label: 'Поиск клиента', prompt: 'Найди письма, связанные с клиентом по имени "Дани", и покажи тему, отправителя и дату для каждого результата.' },
            { role: 'Обслуживание клиентов', label: 'Сводка по обработке', prompt: 'Найди письма на тему "коммерческое предложение" и составь сводку: что требует внимания и что уже закрыто.' },
            { role: 'Обслуживание клиентов', label: 'Черновик ответа', prompt: 'Составь профессиональное письмо клиенту с подтверждением, что мы получили документы и вернёмся с ответом до завтра. Не отправляй без моего утверждения.' },
            { role: 'Обслуживание клиентов', label: 'Недельный календарь', prompt: 'Проанализируй и составь сводку событий моего календаря на следующие семь дней по дням и времени, включая напоминания/оповещения и возможные пересечения.' },
            { role: 'Обслуживание клиентов', label: 'Синхронизация календаря', prompt: 'Выполни полную синхронизацию подключений Google/Outlook, затем кратко суммируй, что обновилось в календаре.' },
            { role: 'Обслуживание клиентов', label: 'Создание события', prompt: 'Создай событие в календаре на завтра в 10:00 с названием "Звонок клиенту для контроля" длительностью один час, с напоминанием за 15 минут. Покажи подтверждение перед выполнением.' },
            { role: 'Продажи', label: 'Горячие лиды', prompt: 'Найди письма за последнюю неделю, которые намекают на лид или запрос предложения, и упорядочи их по вероятности закрытия сделки.' },
            { role: 'Продажи', label: 'Письмо-напоминание', prompt: 'Подготовь короткое письмо клиенту с запросом недостающих данных для предложения. Покажи мне получателя, тему и содержимое перед утверждением отправки.' },
            { role: 'Продажи', label: 'Почтовые аккаунты', prompt: 'Покажи все почтовые аккаунты, подключённые к моему пользователю, включая отображаемое имя и протокол.' },
            { role: 'Продажи', label: 'Облачные подключения', prompt: 'Покажи мои активные подключения Google Drive и Dropbox и настроенные для них правила архивации.' },
            { role: 'Продажи', label: 'Личная память', prompt: 'Запомни, что я предпочитаю получать сводки на русском языке, с действиями к выполнению вверху списка и без лишних деталей.' },
        ],
    },

    // ==================== PWA INSTALL BANNER ====================
    pwa: {
        installSubtitle: 'Установите приложение для более быстрой работы',
        iosHowTo: 'Чтобы установить на iPhone:',
        iosStep1: '1. Нажмите кнопку «Поделиться»',
        iosStep2: '2. Прокрутите вниз и выберите «На экран "Домой"»',
        iosStep3: '3. Нажмите «Добавить» в верхнем углу',
        gotIt: 'Понятно',
        installInstructions: 'Инструкция по установке',
        installApp: 'Установить приложение',
        notNow: 'Не сейчас',
        noStoreNeeded: 'Без загрузки из магазина • Быстрый доступ с главного экрана',
    },

    // ==================== PAYMENT RESULT ====================
    payment: {
        successTitle: 'Оплата завершена | Email Lion',
        failureTitle: 'Оплата не прошла | Email Lion',
        successHeading: 'Оплата успешно завершена!',
        successBody: 'Спасибо за покупку. Тариф будет активирован в ближайшее время, и вы получите письмо с деталями активации.',
        loginBtn: 'Войти в систему',
        homeBtn: 'Главная страница',
        failureHeading: 'Оплата не была завершена',
        failureBody: 'Произошла ошибка при обработке платежа. Попробуйте ещё раз или свяжитесь со службой поддержки.',
        tryAgain: 'Попробовать снова',
    },
};

export default ru;
